function getUrlParams() {
    var query = location.search;
    var returnObject = {};

    if (query) {
        query = query.replace('?', '');
        var params = query.split('&');
        params.forEach(function(param) {
            var paramKeyAndValue = param.split('=');
            returnObject[paramKeyAndValue[0]] = paramKeyAndValue[1];
        });

        return returnObject;
    }

    return null;
}

function getUrlWithParams(url) {
    var params = getUrlParams();
    if (params && params.Parceiro) {
        url += '?Parceiro=' + params.Parceiro;
    }

    return url;
}

jQuery('.advertising').ready(function() {
	jQuery('.advertising').each(function() {
		var theDiv = jQuery(this).parent('div').children('div'),
        id = theDiv.attr('id'),
        parentId = jQuery(this).parent('div').parent('div').attr('id'),
        elementParent = jQuery(this).parent('div');
		if( parentId == 'super'){
			var width = 728;
		    if(typeof(jQuery('#'+id+'_ad_container').children('ins').css('width')) == 'string'){
		        width = jQuery('#'+id+'_ad_container').children('ins').css('width');
            }else if( typeof(jQuery('#google_ads_div_TailTarget_Astrologia_Personare_728x90_ad_container')) == "object" ){
                width = 728;
		    }else if(typeof(jQuery('#'+id+'_ad_container').children('div').css('width')) == 'string'){
		        width = jQuery('#'+id+'_ad_container').children('div').css('width');
            }
			jQuery(this).parent('div').parent('div').css('width',width);
		}
		if( elementParent.hasClass('superbanner_footer') ){
            var width = "";
            width = jQuery('#'+id+'_ad_container').children('ins').css('width');
            jQuery(this).parent('div.superbanner_footer').css('width',width);
        }
		if(theDiv.children('div').attr('id') == id+'_ad_container'){
			jQuery(this).delay(350).removeClass('off');
			if( parentId == 'dhtml' ){
				jQuery('#dhtml').delay(350).removeClass('off');
			}
		}
        //selos
        if( elementParent.hasClass('header_banner3') || elementParent.hasClass('header_banner2') || elementParent.hasClass('header_banner')){
            if(theDiv.children('div').attr('id') != id+'_ad_container'){
                elementParent.addClass('off');
            }
        }
	});
});
// html5shiv MIT @rem remysharp.com/html5-enabling-script
// iepp v1.6.2 MIT @jon_neal iecss.com/print-protector
/*@cc_on(function(m,c){var z="abbr|article|aside|audio|canvas|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video";function n(d){for(var a=-1;++a<o;)d.createElement(i[a])}function p(d,a){for(var e=-1,b=d.length,j,q=[];++e<b;){j=d[e];if((a=j.media||a)!="screen")q.push(p(j.imports,a),j.cssText)}return q.join("")}var g=c.createElement("div");g.innerHTML="<z>i</z>";if(g.childNodes.length!==1){var i=z.split("|"),o=i.length,s=RegExp("(^|\\s)("+z+")",
"gi"),t=RegExp("<(/*)("+z+")","gi"),u=RegExp("(^|[^\\n]*?\\s)("+z+")([^\\n]*)({[\\n\\w\\W]*?})","gi"),r=c.createDocumentFragment(),k=c.documentElement;g=k.firstChild;var h=c.createElement("body"),l=c.createElement("style"),f;n(c);n(r);g.insertBefore(l,
g.firstChild);l.media="print";m.attachEvent("onbeforeprint",function(){var d=-1,a=p(c.styleSheets,"all"),e=[],b;for(f=f||c.body;(b=u.exec(a))!=null;)e.push((b[1]+b[2]+b[3]).replace(s,"$1.iepp_$2")+b[4]);for(l.styleSheet.cssText=e.join("\n");++d<o;){a=c.getElementsByTagName(i[d]);e=a.length;for(b=-1;++b<e;)if(a[b].className.indexOf("iepp_")<0)a[b].className+=" iepp_"+i[d]}r.appendChild(f);k.appendChild(h);h.className=f.className;h.innerHTML=f.innerHTML.replace(t,"<$1font")});m.attachEvent("onafterprint",
function(){h.innerHTML="";k.removeChild(h);k.appendChild(f);l.styleSheet.cssText=""})}})(this,document);@*/

(function(window, undefined) {
    var NeXT = (function() {
        var NeXT = function (anObject) {
            // returns a new object based on given params
            return new NeXT.fn.init(anObject);
        };

        NeXT.fn = NeXT.prototype = {
            constructor : NeXT,
            init: function(anObject) {
                this.length = 1;
                this[0] = anObject;
                return this;
            },
            log: function() {
                NeXT.log(this);
                return this;
            },
            push: function(aNewObject) {
                this.length += 1;
                this[this.length - 1] = aNewObject;
                return this;
            },
            length : 0,
            toArray: function() {
		        return Array.prototype.slice.call( this, 0 );
	        }
        };

        NeXT.fn.init.prototype = NeXT.fn;

        // Métodos do Framework
        /***
         * Fail safe console.log. Will log the arguments
         */
        NeXT.log = function () {
            if (typeof console !== 'undefined' && typeof console.log === 'function') {
                console.log([].slice.call(arguments));
            }
        };

        /***
         * Get a plugin to use right after it's load.
         * Can send a callback to execute with the ready state of plugin
         * Callback is optional. Script can be a framework pre-installed plugin (just give the name of it)
         * or there can be called a external source, using the entire url, including the http:// or https://
         * @param scriptName
         * @param callback
         */
        NeXT.loadPlugin = function(scriptName, callback) {
            var prefix = '', suffix = '';
            if ( (scriptName.indexOf('http://') < 0) && (scriptName.indexOf('https://') < 0) ) {
                prefix = PSR_CDN_ASSETS_URL + 'js/Plugins/';
                suffix = '.js';
            }
            jQuery.getScript(prefix + scriptName + suffix).done(callback);
        };

        NeXT.onReady = [];

        NeXT.consumeArray = function (collection) {
            var onefu, i = 0;
            if (typeof collection !== typeof []) {
                return;
            }

            while (collection.length) {
                onefu = collection.shift();
                if (typeof onefu === 'function') {
                    onefu();
                }
            }
        };

        NeXT.createScript = function (scriptName, isSync, domain) {
            var elementName = 'script',
                oScript = document.createElement(elementName);

            isSync = (isSync ? true : false);
            oScript.src = domain + 'js/' + scriptName + '.js';
            oScript.async = !isSync;
            oScript.defer = !isSync;
            oScript.type = "text/javascript";
            document.getElementsByTagName("head")[0].appendChild(oScript);
        };

        /**
         * NeXT Player = calls a HTML5 audio and video player with flash fallback
         * @param instance = (string) instance name to create (you can have multiple players in a single page)
         * @param playlist = (array of objects) playlist array as seen in this example bellow
         * @param supplied = (string) file types supplied, default is "mp3, oga"
         * @param autoplay = (boolean) true to autoplay as player loads
         *
         *
         * HTML should be like:
         *
         *   <div id="next_player_1" class="jp-jplayer"></div>
         *
         *   <div class="jp-audio">
         *       <div class="jp-type-playlist">
         *           <div id="jp_interface_1" class="jp-interface">
         *               <ul class="jp-controls">
         *                   <li><a href="#" class="jp-play" tabindex="1">play</a></li>
         *                   <li><a href="#" class="jp-pause" tabindex="1">pause</a></li>
         *                   <li><a href="#" class="jp-stop" tabindex="1">stop</a></li>
         *                   <li><a href="#" class="jp-mute" tabindex="1">mute</a></li>
         *                   <li><a href="#" class="jp-unmute" tabindex="1">unmute</a></li>
         *                   <li><a href="#" class="jp-previous" tabindex="1">anterior</a></li>
         *                   <li><a href="#" class="jp-next" tabindex="1">próxima</a></li>
         *               </ul>
         *               <div class="jp-progress">
         *                   <div class="jp-seek-bar">
         *                       <div class="jp-play-bar"></div>
         *                   </div>
         *               </div>
         *               <div class="jp-volume-bar">
         *                   <div class="jp-volume-bar-value"></div>
         *               </div>
         *               <div class="jp-current-time"></div>
         *               <div class="jp-duration"></div>
         *           </div>
         *           <div id="jp_playlist_1" class="jp-playlist">
         *               <ul>
         *                   <!-- The method Playlist.displayPlaylist() uses this unordered list -->
         *                   <li></li>
         *               </ul>
         *           </div>
         *       </div>
         *   </div>
         *
         *   And JS:
         *
         *   var audioPlaylist = [
         *       {
         *           name:"Tempered Song",
         *           free:true,
         *           mp3:"/audio/Miaow-01-Tempered-song.mp3"
         *       },
         *       {
         *           name:"Hidden",
         *           free:true,
         *           mp3:"/audio/Miaow-02-Hidden.mp3"
         *       },
         *       {
         *           name:"Lentement",
         *           free:true,
         *           mp3:"/audio/Miaow-03-Lentement.mp3"
         *       },
         *       {
         *           name:"Lismore",
         *           free:true,
         *           mp3:"/audio/Miaow-04-Lismore.mp3"
         *       },
         *       {
         *           name:"The Separation",
         *           free:true,
         *           mp3:"/audio/Miaow-05-The-separation.mp3"
         *       }
         *
         *   ];
         */
        NeXT.player = function (instance, playlist, supplied, autoplay) {
            var loadPlayer = function (instance, playlist, supplied, autoplay) {
                instance = (instance && typeof instance === 'string') ? instance : '1';
                supplied = (supplied && typeof supplied === 'string') ? supplied : 'mp3, oga';
                var instancedPlaylist = false;
                var SWF_PATH = PSR_CDN_STATIC_URL + '../../activex/Plugins/Jplayer.swf';

                if (playlist) {
                    instancedPlaylist = new Playlist(instance, playlist, {
                        ready: function () {
                            instancedPlaylist.displayPlaylist();
                            // Parameter is a boolean for autoplay.
                            instancedPlaylist.playlistInit(autoplay);
                        },
                        ended: function() {
                            instancedPlaylist.playlistNext();
                        },
                        play: function() {
                            jQuery(this).jPlayer("pauseOthers");
                        },
                        swfPath: SWF_PATH,
                        solution: "html, flash",
                        supplied: supplied
                    });
                }

                jQuery('#next_player_'+instance).jPlayer({
                    solution: "html, flash",
                    swfPath: SWF_PATH
                });
            };

            if (window.Playlist) {
                loadPlayer(instance, playlist, supplied, autoplay);
            } else {
                NeXT.loadPlugin('jplayer', function () {
                    loadPlayer(instance, playlist, supplied, autoplay);
                });
            }
        };

        return NeXT;
    })();

    window.NeXT = NeXT;
})(window);

jQuery(function($) {
    NeXT.consumeArray(NeXT.onReady);
});

jQuery(window).load(function() {
    NeXT.consumeArray(NeXT.onReady);
});

// jQuery form reset (enable .reset() to forms selected by jQuery)
jQuery.fn.extend({
    reset: function() {
        return this.each(function() {
            jQuery(this).is('form') && this.reset();
        });
    }
});

if (!window['plog'] || typeof window['plog'] == 'undefined') {
    function plog() {
        if (typeof console != 'undefined') {
            console.log(arguments[0]);
        } else if ( arguments[1] ) {
            alert(arguments[0]);
        }
    }
}

jQuery.fn.extend({
    plog: function() {
        plog(this);
        return this;
    }
});

function returnjQueryNameOrId(nameOrId) {
    return jQuery('[name='+nameOrId+']').length ? jQuery('[name='+nameOrId+']') : jQuery('#'+nameOrId);
}

// http://jdbartlett.github.com/innershiv | WTFPL License
window.innerShiv = (function() {
	var div, frag,
		inaTable = /^<(tbody|tr|td|col|colgroup|thead|tfoot)/i,
		remptyTag = /(<([\w:]+)[^>]*?)\/>/g,
		rselfClosing = /^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i,
		fcloseTag = function (all, front, tag) {
			return rselfClosing.test(tag) ? all : front + '></' + tag + '>';
		};

	return function(html, returnFrag) {
		if (!div) {
			div = document.createElement('div');
			frag = document.createDocumentFragment();
			/*@cc_on div.style.display = 'none';@*/
		}

		html = html.replace(/^\s\s*/, '').replace(/\s\s*$/, '');

		var tabled = html.match(inaTable), myDiv = div.cloneNode(true);
		if (tabled) html = '<table>' + html + '</table>';

		/*@cc_on document.body.appendChild(myDiv);@*/
		myDiv.innerHTML = html.replace(remptyTag, fcloseTag);
		/*@cc_on document.body.removeChild(myDiv);@*/

		if (tabled) myDiv = myDiv.getElementsByTagName(tabled[1])[0].parentNode;

		if (returnFrag === false) return myDiv.childNodes;

		var myFrag = frag.cloneNode(true), i = myDiv.childNodes.length;
		while (i--) myFrag.appendChild(myDiv.firstChild);

		return myFrag;
	};
}());


function include(arquivo) {
    jQuery('<script type="text/javascript" src="' + arquivo + '"></script>')
            .appendTo('body');
}

objPageParams = null;

/**
 *  http://kevin.vanzonneveld.net
 *  +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
 *  + namespaced by: Michael White (http://crestidg.com)
 *  -    depends on: utf8_encode
 *  *     example 1: md5('Kevin van Zonneveld');
 *  *     returns 1: '6e658d4bfcb59cc13f96c14450ac40b9'
 *
 * @param str
 */
function md5(str) {
    var RotateLeft = function(lValue, iShiftBits) {
        return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
    };

    var AddUnsigned = function(lX, lY) {
        var lX4,lY4,lX8,lY8,lResult;
        lX8 = (lX & 0x80000000);
        lY8 = (lY & 0x80000000);
        lX4 = (lX & 0x40000000);
        lY4 = (lY & 0x40000000);
        lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
        if (lX4 & lY4) {
            return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
        }
        if (lX4 | lY4) {
            if (lResult & 0x40000000) {
                return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
            } else {
                return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
            }
        } else {
            return (lResult ^ lX8 ^ lY8);
        }
    };

    var F = function(x, y, z) {
        return (x & y) | ((~x) & z);
    };
    var G = function(x, y, z) {
        return (x & z) | (y & (~z));
    };
    var H = function(x, y, z) {
        return (x ^ y ^ z);
    };
    var I = function(x, y, z) {
        return (y ^ (x | (~z)));
    };

    var FF = function(a, b, c, d, x, s, ac) {
        a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
        return AddUnsigned(RotateLeft(a, s), b);
    };

    var GG = function(a, b, c, d, x, s, ac) {
        a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
        return AddUnsigned(RotateLeft(a, s), b);
    };

    var HH = function(a, b, c, d, x, s, ac) {
        a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
        return AddUnsigned(RotateLeft(a, s), b);
    };

    var II = function(a, b, c, d, x, s, ac) {
        a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
        return AddUnsigned(RotateLeft(a, s), b);
    };

    var ConvertToWordArray = function(str) {
        var lWordCount;
        var lMessageLength = str.length;
        var lNumberOfWords_temp1 = lMessageLength + 8;
        var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
        var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
        var lWordArray = Array(lNumberOfWords - 1);
        var lBytePosition = 0;
        var lByteCount = 0;
        while (lByteCount < lMessageLength) {
            lWordCount = (lByteCount - (lByteCount % 4)) / 4;
            lBytePosition = (lByteCount % 4) * 8;
            lWordArray[lWordCount] = (lWordArray[lWordCount] | (str.charCodeAt(lByteCount) << lBytePosition));
            lByteCount++;
        }
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
        lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
        lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
        return lWordArray;
    };

    var WordToHex = function(lValue) {
        var WordToHexValue = "",WordToHexValue_temp = "",lByte,lCount;
        for (lCount = 0; lCount <= 3; lCount++) {
            lByte = (lValue >>> (lCount * 8)) & 255;
            WordToHexValue_temp = "0" + lByte.toString(16);
            WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
        }
        return WordToHexValue;
    };

    var x = Array();
    var k,AA,BB,CC,DD,a,b,c,d;
    var S11 = 7, S12 = 12, S13 = 17, S14 = 22;
    var S21 = 5, S22 = 9 , S23 = 14, S24 = 20;
    var S31 = 4, S32 = 11, S33 = 16, S34 = 23;
    var S41 = 6, S42 = 10, S43 = 15, S44 = 21;

    str = utf8_encode(str);
    x = ConvertToWordArray(str);
    a = 0x67452301;
    b = 0xEFCDAB89;
    c = 0x98BADCFE;
    d = 0x10325476;

    for (k = 0; k < x.length; k += 16) {
        AA = a;
        BB = b;
        CC = c;
        DD = d;
        a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
        d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
        c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
        b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
        a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
        d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
        c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
        b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
        a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
        d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
        c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
        b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
        a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
        d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
        c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
        b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
        a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
        d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
        c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
        b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
        a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
        d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
        c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
        b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
        a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
        d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
        c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
        b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
        a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
        d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
        c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
        b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
        a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
        d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
        c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
        b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
        a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
        d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
        c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
        b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
        a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
        d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
        c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
        b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
        a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
        d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
        c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
        b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
        a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
        d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
        c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
        b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
        a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
        d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
        c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
        b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
        a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
        d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
        c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
        b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
        a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
        d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
        c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
        b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
        a = AddUnsigned(a, AA);
        b = AddUnsigned(b, BB);
        c = AddUnsigned(c, CC);
        d = AddUnsigned(d, DD);
    }

    var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);

    return temp.toLowerCase();
}

function seeAnotherProfileMothersDay() {
    SetCookie('CS', 0);
    location.href = '/astrologia/seu-jeito-de-ser-mae/';
}

var refreshEstate = function (event) {

    var $element = jQuery(event.target);

    if ($element.val() == 23) {
        var data = '';
        SendDataByAjaxRunMethod(data, 'Country', 'getEstateList', {'callback': callbackRefreshEstate});
    } else {
        jQuery('.Estate').addClass('off');
        var $inputSelect = jQuery('#Estate');
        var stateId = ($element.val() == 125) ? 28:0;
        Select.clear($inputSelect, 'Todos', stateId);
    }
};

var callbackRefreshEstate = function(estates) {
    var $inputSelect = jQuery('#Estate');
    Select.refresh($inputSelect, estates, 'EstateSign', 'EstateID');
    jQuery('.Estate').removeClass('off');
};

function utf8_encode(argString) {
  //  discuss at: http://phpjs.org/functions/utf8_encode/
  // original by: Webtoolkit.info (http://www.webtoolkit.info/)
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: sowberry
  // improved by: Jack
  // improved by: Yves Sucaet
  // improved by: kirilloid
  // bugfixed by: Onno Marsman
  // bugfixed by: Onno Marsman
  // bugfixed by: Ulrich
  // bugfixed by: Rafal Kukawski
  // bugfixed by: kirilloid
  //   example 1: utf8_encode('Kevin van Zonneveld');
  //   returns 1: 'Kevin van Zonneveld'

  if (argString === null || typeof argString === 'undefined') {
    return '';
  }

  var string = (argString + ''); // .replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  var utftext = '',
    start, end, stringl = 0;

  start = end = 0;
  stringl = string.length;
  for (var n = 0; n < stringl; n++) {
    var c1 = string.charCodeAt(n);
    var enc = null;

    if (c1 < 128) {
      end++;
    } else if (c1 > 127 && c1 < 2048) {
      enc = String.fromCharCode(
        (c1 >> 6) | 192, (c1 & 63) | 128
      );
    } else if ((c1 & 0xF800) != 0xD800) {
      enc = String.fromCharCode(
        (c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128
      );
    } else { // surrogate pairs
      if ((c1 & 0xFC00) != 0xD800) {
        throw new RangeError('Unmatched trail surrogate at ' + n);
      }
      var c2 = string.charCodeAt(++n);
      if ((c2 & 0xFC00) != 0xDC00) {
        throw new RangeError('Unmatched lead surrogate at ' + (n - 1));
      }
      c1 = ((c1 & 0x3FF) << 10) + (c2 & 0x3FF) + 0x10000;
      enc = String.fromCharCode(
        (c1 >> 18) | 240, ((c1 >> 12) & 63) | 128, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128
      );
    }
    if (enc !== null) {
      if (end > start) {
        utftext += string.slice(start, end);
      }
      utftext += enc;
      start = end = n + 1;
    }
  }

  if (end > start) {
    utftext += string.slice(start, stringl);
  }

  return utftext;
}

function utf8_decode(str_data) {
    // http://kevin.vanzonneveld.net
    // +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
    // +      input by: Aman Gupta
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // *     example 1: utf8_decode('Kevin van Zonneveld');
    // *     returns 1: 'Kevin van Zonneveld'

    var tmp_arr = [], i = ac = c = c1 = c2 = 0;

    while (i < str_data.length) {
        c = str_data.charCodeAt(i);
        if (c < 128) {
            tmp_arr[ac++] = String.fromCharCode(c);
            i++;
        } else if ((c > 191) && (c < 224)) {
            c2 = str_data.charCodeAt(i + 1);
            tmp_arr[ac++] = String.fromCharCode(((c & 31) << 6) | (c2 & 63));
            i += 2;
        } else {
            c2 = str_data.charCodeAt(i + 1);
            c3 = str_data.charCodeAt(i + 2);
            tmp_arr[ac++] = String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
            i += 3;
        }
    }

    return tmp_arr.join('');
}

function base64_encode(data) {
    // http://kevin.vanzonneveld.net
    // +   original by: Tyler Akins (http://rumkin.com)
    // +   improved by: Bayron Guevara
    // +   improved by: Thunder.m
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // -    depends on: utf8_encode
    // *     example 1: base64_encode('Kevin van Zonneveld');
    // *     returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='

    // mozilla has this native
    // - but breaks in 2.0.0.12!
    //if (typeof window['atob'] == 'function') {
    //    return atob(data);
    //}

    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var o1, o2, o3, h1, h2, h3, h4, bits, i = ac = 0, enc = "", tmp_arr = [];
    data = utf8_encode(data);

    do { // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);

        bits = o1 << 16 | o2 << 8 | o3;

        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;

        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);

    enc = tmp_arr.join('');

    switch (data.length % 3) {
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }

    return enc;
}

function base64_decode(data) {
    // http://kevin.vanzonneveld.net
    // +   original by: Tyler Akins (http://rumkin.com)
    // +   improved by: Thunder.m
    // +      input by: Aman Gupta
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // -    depends on: utf8_decode
    // *     example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==');
    // *     returns 1: 'Kevin van Zonneveld'

    // mozilla has this native
    // - but breaks in 2.0.0.12!
    //if (typeof window['btoa'] == 'function') {
    //    return btoa(data);
    //}

    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var o1, o2, o3, h1, h2, h3, h4, bits, i = ac = 0, dec = "", tmp_arr = [];

    do {  // unpack four hexets into three octets using index points in b64
        h1 = b64.indexOf(data.charAt(i++));
        h2 = b64.indexOf(data.charAt(i++));
        h3 = b64.indexOf(data.charAt(i++));
        h4 = b64.indexOf(data.charAt(i++));

        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

        o1 = bits >> 16 & 0xff;
        o2 = bits >> 8 & 0xff;
        o3 = bits & 0xff;

        if (h3 == 64) {
            tmp_arr[ac++] = String.fromCharCode(o1);
        } else if (h4 == 64) {
            tmp_arr[ac++] = String.fromCharCode(o1, o2);
        } else {
            tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
        }
    } while (i < data.length);

    dec = tmp_arr.join('');
    dec = utf8_decode(dec);

    // Trata um bug que acontece quando o código base64 foi gerado pelo PHP em um servidor FreeBSD e é decodificado no
    // Javascript. Isso gerava em alguns casos no final um caracter do tipo “\0? (ASCII 0 (0×00)), the NUL-byte.
    dec = trim(dec, '\0');
    dec = clearInvalidChars(dec);

    return dec;
}

function ascii_value(c) {
    // restrict input to a single character
    c = c.charAt(0);

    // loop through all possible ASCII values
    var i;
    for (i = 0; i < 256; ++ i) {
        // convert i into a 2-digit hex string
        var h = i.toString(16);
        if (h.length == 1)
            h = "0" + h;

        // insert a % character into the string
        h = "%" + h;

        // determine the character represented by the escape code
        h = unescape(h);

        // if the characters match, we've found the ASCII value
        if (h == c)
            break;
    }
    return i;
}


/*****************************************************************************************/


function encodeUser(num) {
    return num * 1427327;
}

function create_request_string(formName) {
    theForm = eval('document.' + formName);
    var reqStr = "";

    for (i = 0; i < theForm.elements.length; i++) {
        isFormObject = false;

        switch (theForm.elements[i].tagName) {
            case "INPUT":

                switch (theForm.elements[i].type) {
                    case "text":
                    case "password":
                    case "hidden":
                    case "file":
                        reqStr += theForm.elements[i].name + "=" + encodeURIComponent(theForm.elements[i].value);
                        isFormObject = true;
                        break;

                    case "checkbox":
                        if (theForm.elements[i].checked) {
                            reqStr += theForm.elements[i].name + "=" + theForm.elements[i].value;
                        } else {
                            reqStr += theForm.elements[i].name + "=";
                        }
                        isFormObject = true;
                        break;

                    case "radio":
                        if (theForm.elements[i].checked) {
                            reqStr += theForm.elements[i].name + "=" + theForm.elements[i].value;
                            isFormObject = true;
                        }
                }
                break;

            case "TEXTAREA":

                reqStr += theForm.elements[i].name + "=" + encodeURIComponent(theForm.elements[i].value);
                isFormObject = true;
                break;

            case "SELECT":
                var sel = theForm.elements[i];
                for (var z = 0; z < sel.options.length; z++) {
                    if (sel.options[ z ].selected) {
                        reqStr += sel.name + "=" + sel.options[z].value;
                        isFormObject = true;
                        reqStr += "&";
                    }
                }
                break;
        }

        if ((isFormObject) && ((i + 1) != theForm.elements.length)) {
            reqStr += "&";
        }

    }

    return reqStr;
}

function createHiddenField(formName, name, value) {
    var form = eval('document.' + formName);

    var input = jQuery('<input type="hidden" name="'+name+'" id="'+name+'" />')
            .val(value);

    input.appendTo(form);
}

function ExecuteAction(formName, urlPhp, className, MethodName) {

    form = eval('document.' + formName);

    form.action = urlPhp;

    if (className != '')
        createHiddenField(formName, 'mdl', className);

    if (MethodName != '')
        createHiddenField(formName, 'cmd', MethodName);

    form.submit();

}

function TestInputText(formularioAux, campoAux, msgErroAux) {

    formElement = 'document.' + formularioAux + '.' + campoAux + '.value';

    formElementExist = eval('document.' + formularioAux + '.' + campoAux);

    if (formElementExist)
        value = eval(formElement);


    if (value != '') {
        return '';
    }
    else {
        return msgErroAux + '\n';
    }
}


function valueInputSelect(formularioAux, campoAux) {

    var teste = jQGetForm(formularioAux).find('[name="'+ campoAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formularioAux).find('#'+campoAux);
    }

    var value = teste.val();


    return (value) ? value : -1 ;
}

function valueInputRadio(formularioAux, campoAux) {
    var teste = jQGetForm(formularioAux).find('[name="'+ campoAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formularioAux).find('#'+campoAux);
    }

    var value = teste.val();
    return (value) ? value : -1 ;
}


function checkValueInputRadio(formularioAux, campoAux, value) {
    var teste = jQGetForm(formularioAux).find('#'+campoAux);

    teste.val(value);
}

function jQGetForm(formNameOrId) {
    var $form = jQuery('form[name="'+formNameOrId+'"]');
    if ($form.length === 0) {
        $form = jQuery('#'+formNameOrId);
    }
    return $form;
}

function valueInputText(formularioAux, campoAux) {

    var $form = jQGetForm(formularioAux);

    var teste = $form.find('[name="'+ campoAux +'"]');

    if (!teste.length) {
        teste = $form.find('#'+campoAux);
    }

    var value = teste.val();
    return (value) ? value : -1 ;
}

function valueInputFile(formularioAux, campoAux) {
    var teste = jQGetForm(formularioAux).find('[name="'+ campoAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formularioAux).find('#'+campoAux);
    }

    var value = teste.val();
    return (value) ;
}

function existInput(formName, input) {
    var teste = jQGetForm(formName).find('[name="'+ input +'"]');

    if (!teste.length) {
        teste = jQGetForm(formName).find('#'+input);
    }

    return ( teste.length > 0 );
}

function setValueInputText(formAux, inputAux, valueAux) {
    var teste = jQGetForm(formAux).find('[name="'+ inputAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formAux).find('#'+inputAux);
    }

    teste.val(valueAux);

}

function setValueInputHidden(formAux, inputAux, valueAux) {
    var teste = jQGetForm(formAux).find('[name="'+ inputAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formAux).find('#'+inputAux);
    }

    teste.val(valueAux);

}

function valueInputHidden(formularioAux, campoAux) {
    var teste = jQGetForm(formularioAux).find('[name="'+ campoAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formularioAux).find('#'+campoAux);
    }

    var value = teste.val();
    return (value);
}

function valueInputCheck(formularioAux, campoAux) {

    var teste = jQGetForm(formularioAux).find('[name="'+ campoAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formularioAux).find('#'+campoAux);
    }

    var value = teste.is(":checked");
    return (value) ? value : -1 ;
}

function verifyInputCheck(formularioAux, inputName) {

    var teste = jQGetForm(formularioAux).find('[name="'+ campoAux +'"]:checked');

    if (!teste.length) {
        teste = jQGetForm(formularioAux).find('#'+campoAux+':checked');
    }

    return (teste.length > 0);
}

function TestInputCheck(formularioAux, campoAux, msgErroAux) {

    var teste = jQGetForm(formularioAux).find('[name="'+ campoAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formularioAux).find('#'+campoAux);
    }

    var value = teste.val();
    return (value) ? '' : msgErroAux + '\n' ;

}

function TestInputRadio(formularioAux, campoAux, msgErroAux) {

    var value = valueInputRadio(formularioAux, campoAux);

    if (value) {
        return '';
    }
    else {
        return msgErroAux + '\n';
    }
}

function TestInputSelect(formularioAux, campoAux, msgErroAux) {
    var teste = jQGetForm(formularioAux).find('[name="'+ campoAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formularioAux).find('#'+campoAux);
    }

    var value = teste.val();

    return (value) ? '' : (msgErroAux + '\n') ;

}

function TestInputSelectMultiple(formularioAux, campoAux, msgErroAux) {

    var teste = jQGetForm(formularioAux).find('[name="'+ campoAux +'"]');

    if (!teste.length) {
        teste = jQGetForm(formularioAux).find('#'+campoAux);
    }

    var tamanhoSelect = teste.length;

    var value = false;
    for (i = 0; i < tamanhoSelect; i++) {
        if (!value) {
            value = eval('document.' + formularioAux + '.ddCidade.options[' + i + '].selected')
        }
    }

    if (value) {
        return '';
    }
    else {
        return msgErroAux + '\n';
    }
}

function AbrePop(a, X, Y) {
    janela2 = window.open(a, 'pop', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,copyhistory=no,width=' + X + ',height=' + Y + ',top=0,left=0,maximized');
}

function ExibeMensagem(Msg) {


    if (Msg == 1) {
        alert('E-mail inserido com sucesso');
    }
    if (Msg == 2) {
        alert('E-mail editado com sucesso');
    }
    if (Msg == 3) {
        alert('Ocorreu um erro ao tentar salvar o e-mail, por favor tente novamente caso o problema persiste entre em contato com nossa equipe de atendimento através do e-mail rodrigues@armazem7.com.br');
    }
}

function scl() {
    setTimeout("scrollBy(0,100000);", 100);
}

function SetCookie(cookieName, cookieValue, nDays) {
    var today = new Date();
    var expire = new Date();

    if (nDays == null)
        nDays = 1;

    expire.setTime(today.getTime() + 3600000 * 24 * nDays);

    if (nDays == 0)
        document.cookie = cookieName + "=" + escape(cookieValue) + "; path=/";
    else
        document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString() + "; path=/";

}

function GetCookie(c_name) {
    var c_start;

    if (document.cookie.length > 0) {

        c_start = document.cookie.indexOf(c_name + "=")

        if (c_start != -1) {

            c_start = c_start + c_name.length + 1


            c_end = document.cookie.indexOf(";", c_start);

            if (c_end == -1) {
                c_end = document.cookie.length;
            }

            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return 0;
}


function ShowHide(elementName) {
    var element = document.getElementById(elementName);
    if (element.style.display == "none") {
        element.style.display = "block";
    } else {
        element.style.display = "none";
    }
}

function DropDownSelectAllOptions(iDselect) {
    var select = document.getElementById(iDselect);
    var i = 0;
    for (i = 0; i < select.options.length; i++) {
        select.options[i].selected = true;
    }
    ShowHide(divSelect);
    ShowHide(divUnselect);
}
function DropDownUnselectAllOptions(iDselect) {
    var select = document.getElementById(iDselect);

    for (i = 0; i < select.options.length; i++) {
        select.options[i].selected = false;
    }
    ShowHide(divSelect);
    ShowHide(divUnselect);
}

function UserLogout(url) {
    SetCookie('UL', 0, 0);
    SetCookie('UC', 0, 0);
    SetCookie('NewUserCameFromHolis', 0, 0);

    if (url == '') {
        document.location.reload();
    } else {
        document.location.href = url;
    }
}

function LoginResult(UserCode) {

    if (UserCode) {
        SetLogin(UserCode);
        if (LoginRedirectURL != '')
            document.location.href = LoginRedirectURL;
        else
            document.location.reload();
    }
    else {
        alert('O login ou senha informados não estão corretos');
        return false;
    }
}

function SetLogin(UserCode) {
    if (UserCode) {
        SetCookie('UL', UserCode, 0);
        SetCookie('UC', UserCode, 3600);
    }
}

function GetUserLogin() {
    userCode = GetCookie('UL');
    return (userCode > 0 && userCode != '');
}

function RemoveItem(ID, mdl, cmd) {
    var remove = confirm('Tem certeza que deseja apagar este registro?');
    if (remove) {
        SendDataByAjaxRunMethod('ID=' + ID, 'Message', 'RemoveMessage', RemoveItemReturn);
    }
}

function RemoveItemReturn(errCode) {
    if (errCode < 0) {
        alert('Ocorreu um erro ao apagar o registro. Reporte o ocorrido ao administrador do sistema atravÃ©s do email bug@metabolikey.com.br.');
    } else {
        document.location.reload();
    }
}


function UploadFile(type, theForm, uploadDiv, uploadField) {
    if (uploadField.value == '') {
        alert('Você precisa selecionar um arquivo');
        return false;
    }
    var fileName = uploadField.value;
    var extension = fileName.substring(fileName.length - 3, fileName.length);
    var extension = extension.toLowerCase();

    if (type == 3) {
        if (extension != 'flv') {
            uploadField.value = '';
            alert('O video precisa estar no formato FLV');
            return false;
        }
    } else {
        if (extension != 'jpg' && extension != 'gif') {
            uploadField.value = '';
            alert('A imagem precisa estar nos formatos JPG ou GIF');
            return false;
        }
    }

    theForm.hdUploadType.value = type;
    theForm.hdUploadFilePath.value = uploadField.value;

    micoxUpload(theForm, 'upload.php', uploadDiv, 'Carregando. Por favor aguarde...', '');

    uploadField.value = '';
}

//--------------Inicio das funçõees de controle de Loading do AJAX -----//

function retornaY(maisY) {
    //var x1 = x2 = x3 = 0;
    var y1 = 0, y2 = 0, y3 = 0;
    if (document.documentElement) {
        y1 = document.documentElement.scrollTop || 0;
    }
    if (document.body) {
        y2 = document.body.scrollTop || 0;
    }

    y3 = window.scrollY || 0;
    var y = Math.max(y1, Math.max(y2, y3)) + maisY;
    return y;
}

function mostraLoader() {
    var $loader = jQuery("#loadingClip");
    var $window = jQuery(window);
    $loader.css({
        'position': 'absolute',
        'display': 'inline',
        'top': $window.height() / 2 + ($window.scrollTop() - 50) + 'px',
        'left': '50%',
        'marginLeft': '-' + ($loader.width() / 2) + 'px'
    });
}

function escondeLoader() {
    jQuery("#loadingClip").hide();
}

//-------------- Fim das funções de controle de Loading do AJAX -----//

function goToLink(pagina) {
    this.window.location(pagina);
}

/* Deprecated function */
function showDiv(ID) {
    jQuery('#' + ID).show();
}
/* Deprecated function */
function hideDiv(ID) {
    jQuery('#' + ID).hide();
}

function redimensionaFundo() {
    jQuery('#fundo_pop_carrinho')
            .height(document.body.scrollHeight)
            .width(document.body.scrollWidth);
}
function redimensionaFundo2() {
    jQuery('#fundo_pop_carrinho')
            .height(document.body.scrollHeight)
            .width(document.body.scrollWidth);
}

function ShowPOP(Template, Data, type) {
    var Type = type;
    SendDataByAjaxRunTemplate(Template, Data, SetPOPContent);
}

function SetPOPContent(content) {
	SetDivContent(content);
    hideActiveX();
}

function ClosePOP(Template) {
    showActiveX();
}

function CloseDiv(Template) {
    var name = TemplateNameToDivName(Template)
    jQuery('#' + name).empty();
}

function TemplateNameToJSName(templateName) {
    while (templateName.indexOf('/') != -1) {
        templateName = templateName.replace('/', '');
    }
    return templateName.toLowerCase();
}

function CreateScript(scriptName, versionTagName) {
    var elementName = TemplateNameToJSName('script');
    var divId = TemplateNameToDivName(scriptName);
    var oScript = document.createElement(elementName);
    if(versionTagName.length > 1){
        oScript.src = '/control/' + versionTagName + '/Slices/' + scriptName + '.js';
    }else{
        oScript.src = '/control/Slices/' + scriptName + '.js';
    }
    oScript.type = "text/javascript";
    document.getElementsByTagName("head")[0].appendChild(oScript);
}

function CreateCustomScript(scriptName, customSite, versionTagName) {
    var elementName = TemplateNameToJSName('script');
    var divId = TemplateNameToDivName(scriptName);
    var oScript = document.createElement(elementName);
    if(versionTagName.length > 1){
        oScript.src = '/control/' + customSite + '/' + versionTagName + '/Slices/' + scriptName + '.js';
    }else{
        oScript.src = '/control/' + customSite + '/Slices/' + scriptName + '.js';
    }
    oScript.type = "text/javascript";
    document.getElementsByTagName("head")[0].appendChild(oScript);
}


function FileExists(strURL) {
    var oHttp = window.ActiveXObject ? new ActiveXObject("Microsoft.XMLHTTP") : new XMLHttpRequest();
    oHttp.open("GET", strURL, false);
    oHttp.send();
    return (!oHttp.responseText.indexOf("404 - File not found"));
}

/*
 MOVE this to the <body>:
 */
var ns4 = document.layers;
var ns6 = document.getElementById && !document.all;
var ie4 = document.all;
offsetX = 0;
offsetY = 20;
var toolTipSTYLE = "";

function initToolTips() {
    if (ns4 || ns6 || ie4) {
        if (ns4) toolTipSTYLE = document.toolTipLayer;
        else if (ns6) toolTipSTYLE = document.getElementById("toolTipLayer").style;
        else if (ie4) toolTipSTYLE = document.all.toolTipLayer.style;
        if (ns4) document.captureEvents(Event.MOUSEMOVE);
        else {
            toolTipSTYLE.visibility = "visible";
            toolTipSTYLE.display = "none";
        }
        document.onmousemove = moveToMouseLoc;
    }
}

function toolTip(msg, fg, bg) {
    if (toolTip.arguments.length < 1) {
        if (ns4) toolTipSTYLE.visibility = "hidden";
        else toolTipSTYLE.display = "none";
    } else {
        if (!fg) fg = "";
        if (!bg) bg = "";
        var content =
                '<table width="200px" border="0" cellspacing="0" cellpadding="1" bgcolor="' + fg + '"><td>' +
                        '<table border="0" cellspacing="0" cellpadding="2" bgcolor="' + bg +
                        '"><td><font face="sans-serif" color="' + fg +
                        '" size="2px">' + msg +
                        '&nbsp\;</font></td></table></td></table>';
        if (ns4) {
            toolTipSTYLE.document.write(content);
            toolTipSTYLE.document.close();
            toolTipSTYLE.visibility = "visible";
        }
        if (ns6) {
            document.getElementById("toolTipLayer").innerHTML = content;
            toolTipSTYLE.display = 'block'
        }
        if (ie4) {
            document.all("toolTipLayer").innerHTML = content;
            toolTipSTYLE.display = 'block';
        }
    }
}
function moveToMouseLoc(e) {
    if (ns4 || ns6) {
        x = e.pageX;
        y = e.pageY;
    }
    else {
        x = event.x + document.body.scrollLeft;
        y = event.y + document.body.scrollTop;
    }
    //toolTipSTYLE.left = x + offsetX;
    //toolTipSTYLE.top = y + offsetY;
    toolTipSTYLE.left = x - 120 + "px";
    toolTipSTYLE.top = y - 95 + "px";
    //document.write(document.onmousemove);
    return true;
}

function clearInvalidChars(param) {
    var length = param.length;
    var string = '';

    for (i = 0; length > i; i++) {
        if ((param.charCodeAt(i) != 0) || (param.charCodeAt(i) != '') || (param.charCodeAt(i) != false)) {
            string = string + param.charAt(i);
        }
    }
    return string;
}

function trim(str, chars) {
    return ltrim(rtrim(str, chars), chars);
}

function ltrim(str, chars) {
    chars = chars || "\\s";
    return str.replace(new RegExp("^[" + chars + "]+", "g"), "");
}

function rtrim(str, chars) {
    chars = chars || "\\s";
    return str.replace(new RegExp("[" + chars + "]+$", "g"), "");
}
function validaCPF(cpf) {
    var i;
    var soma = 0, soma2 = 0;

    if (!(cpf.match(/^[0-9]{3,3}[.]{0,1}[0-9]{3,3}[.]{0,1}[0-9]{3,3}[-]{0,1}[0-9]{2,2}$/))) {
        return false;
    }

    cpf = retiraCaracter(retiraCaracter(cpf, '.'), '-');

    for (i = 0; i < 10; i++) {
        if (i < 9) {
            soma += cpf.charAt(i) * (10 - i);
        }
        soma2 += cpf.charAt(i) * (11 - i);
    }

    if (((soma % 11) < 2 ? 0 : 11 - (soma % 11 )) != cpf.charAt(9)) {
        return false;
    }

    return (((soma2 % 11 ) < 2 ? 0 : 11 - (soma2 % 11 )) != cpf.charAt(10)) ? false : true;
}

function retiraCaracter(string, caracter) {
    var i = 0;
    var final = '';
    while (i < string.length) {
        if (string.charAt(i) == caracter) {
            final += string.substr(0, i);
            string = string.substr(i + 1, string.length - (i + 1));
            i = 0;
        }
        else {
            i++;
        }
    }
    return final + string;
}

function verifyGiftSelect() {
    var $el = jQuery('#FormGiftTool');
    var $checkboxes = $el.find(':checkbox');
    var checkedCount = $checkboxes.filter(':checked').length;

    if (checkedCount > 0 && checkedCount <= 3) {
        return true;
    } else {
        return false;
    }
}

/*

 Correctly handle PNG transparency in Win IE 5.5 & 6.
 http://homepage.ntlworld.com/bobosola. Updated 18-Jan-2006.

 use dentro das tags <HEAD> com o comentário condicional abaixo:
 <!--[if lt IE 7]>
 <script defer type="text/javascript" src="pngfix.js"></script>
 <![endif]-->


 não esquecendo de colocar a propriedade onLoad="fixPng()" na tag <BODY>

 */

function fixPng() {
    var arVersion = navigator.appVersion.split("MSIE")
    var version = parseFloat(arVersion[1])

    if ((version >= 5.5) && (document.body.filters)) {
        for (var i = 0; i < document.images.length; i++) {
            var img = document.images[i]
            var imgName = img.src.toUpperCase()
            if (imgName.substring(imgName.length - 3, imgName.length) == "PNG") {
                var imgID = (img.id) ? "id='" + img.id + "' " : ""
                var imgClass = (img.className) ? "class='" + img.className + "' " : ""
                var imgTitle = (img.title) ? "title='" + img.title + "' " : "title='" + img.alt + "' "
                var imgStyle = "display:inline-block;" + img.style.cssText
                if (img.align == "left") imgStyle = "float:left;" + imgStyle
                if (img.align == "right") imgStyle = "float:right;" + imgStyle
                if (img.parentElement.href) imgStyle = "cursor:hand;" + imgStyle
                var strNewHTML = "<span " + imgID + imgClass + imgTitle
                        + " style=\"" + "width:" + img.width + "px; height:" + img.height + "px;" + imgStyle + ";"
                        + "filter:progid:DXImageTransform.Microsoft.AlphaImageLoader"
                        + "(src=\'" + img.src + "\', sizingMethod='scale');\"></span>"
                img.outerHTML = strNewHTML
                i = i - 1
            }
        }
    }
}

function RedirectToUrl(url) {
    document.location.href = url;
}

function PositionDiv(div) {
    var scrOfY = 0;
    if (typeof( window.pageYOffset ) == 'number') {
        //Netscape compliant
        scrOfY = window.pageYOffset;
    } else if (document.body && ( document.body.scrollLeft || document.body.scrollTop )) {
        //DOM compliant
        scrOfY = document.body.scrollTop;
    } else if (document.documentElement && ( document.documentElement.scrollLeft || document.documentElement.scrollTop )) {
        //IE6 standards compliant mode
        scrOfY = document.documentElement.scrollTop;
    }
    document.getElementById(div).style.top = (scrOfY + 10) + 'px';
    document.getElementById(div).style.left = (((document.body.clientWidth) - (document.getElementById(div).style.width.substr(0, document.getElementById(div).style.width.length - 2))) / 2) + 'px';
}
/*
function hideActiveX() {
    jQuery('select, object').hide();
}

function showActiveX() {
    jQuery('select, object').show();
}
*/
function maxLength(field, keyCode, maxChars) {
    if (keyCode != 8 && keyCode != 46 && keyCode != 116 && keyCode != 37 && keyCode != 38 && keyCode != 39 && keyCode != 40) {
        if (field.value.length >= maxChars) {
            alert("Você atingiu o limite de " + maxChars + " caracteres");
            return false;
        }
    }
}

function maxLengthPaste(field, maxChars) {
    return;
}

function OpenURL(url) {
    if (GetUserLogin()) {
        RedirectToUrl(url);
    }
    else {
        var data = 'URL=' + url
        SendDataByAjaxRunTemplate('User/Login', data, SetDivContent)
        //hideActiveX();
    }
}

function CloseLogin() {
    jQuery('#user_login').html('');
    showActiveX();
}

function rEs(tO) {
    var i, n;
    if (!tO) {
        return false;
    } //RemoveElements
    if (!tO.nodeName) {
        if (!tO.length) {
            return false;
        }
        for (n = tO.length; n--;) {
            if (!rEs(tO[n])) {
                return false;
            }
        }
        return true;
    } else {
        tO.parentNode.removeChild(tO);
        return true;
    }
}

function textCounter(field, countfield, maxlimit) {
    if (field.value.length > maxlimit) {
        field.value = field.value.substring(0, maxlimit);
    } else {
        jQuery('#' + countfield).html('').html(field.value.length);
    }
}

function gFETN(tTn, tFs, isER, rE, justChilds) {
    //getFilteredElements[by]TagName: <str TagName> [, str/arr theFilters [, bool isERFilter [, object rootElement]]]
    //Se o quarto parÃ¢metro for enviado, a funÃ§Ã£o sÃ³ retornarÃ¡ elementos descendentes de _rootElement_.
    //O quinto parÃ¢metro, _justChilds_, faz a funÃ§Ã£o sÃ³ retornar filhos diretos do elemento estabelecido em _rootElement_.
    var tEs, i, n, ii, nn, passed, tF, tER, tR = new Array();
    if (rE && justChilds) {
        tEs = childsOfType(rE, tTn);
    } else {
        tEs = (rE || document).getElementsByTagName(tTn);
    }
    if (!tFs) {
        return tEs.length ? makeArray(tEs, 1) : false;
    }
    if (typeof(tFs) == 'string') {
        tFs = [tFs];
    }
    for (n = tEs.length,i = 0; i < n; i++) {
        passed = 1;
        for (nn = tFs.length,ii = 0; ii < nn; ii++) {
            tF = tFs[ii].split('=');
            if (isER) {
                tER = new RegExp(tF[1], 'g');
                if (!tER.test(tEs[i][tF[0]])) {
                    passed = 0;
                }
            }
            else {
                if (tEs[i][tF[0]] != tF[1]) passed = 0;
            }
        }
        if (passed) {
            tR[tR.length] = tEs[i];
            /* compatÃ?Â­vel com IE5.1 */
        }
    }
    return tR.length ? tR : false;
}

function childsOfType(tO, tT) { /* tParentObject, <string/arr tTag(s)> */
    var i, n, tCs, tR = [];
    tT = new RegExp((tT instanceof Array) ? tT.join('|') : tT, 'i');
    for (i = 0,n = (tCs = tO.childNodes).length; i < n; i++) {
        if (tCs[i].nodeType == 1 && tT.test(tCs[i].nodeName.toLowerCase())) tR[tR.length] = tCs[i];
    }
    return tR.length ? tR : false;
}

function addTok(tokList, tTok, tDiv, duplicate) {
    tDiv = tDiv || ' ';
    if (hasTok(tokList, tTok, tDiv) && !duplicate) {
        return tokList;
    }
    return ((tokList) ? (tokList + tDiv) : '') + tTok;
}

function hasTok(tokList, tTok, tDiv) {
    var n, i, tToks = tokList.split(tDiv || ' ');
    for (n = tToks.length; n--;) {
        if (tToks[n] == tTok) {
            return true;
        }
    }
    return false;
}

function remTok(tokList, tTok, tDiv) {
    if (!tokList) return '';
    var n, i, tRs = [];
    tDiv = tDiv || ' ';
    var tToks = tokList.split(tDiv);
    for (n = tToks.length,i = 0; i < n; i++) {
        if (tToks[i] != tTok) {
            tRs[tRs.length] = tToks[i];
        }
    }
    return tRs.length ? tRs.join(tDiv) : '';
}

function isDescendantOf(mayBeChild, mayBeParent) {
    return !!jQuery(mayBeChild).parents(mayBeParent).length;
}

function nextObject(tE) {
    var n = jQuery(tE);

    return n.next();
}

function previousObject(tE) {
    var p = jQuery(tE);
    return n.prev();
}

function isIE6() {
    var IE6 = false;
    return IE6;
}
function verifyDate(date) {
    var auxDate = new Array();
    auxDate[0] = date.substr(6, 2);
    auxDate[1] = date.substr(4, 2);
    auxDate[2] = date.substr(0, 4);

    if (auxDate.length < 3) {
        return false;
    }

    var day = auxDate[0];
    var month = auxDate[1] - 1;
    var year = auxDate[2];

    /* Using form values, create a new date object
     using the setFullYear function */
    var myDate = new Date();
    myDate.setFullYear(year, month, day);

    if (myDate.getMonth() != month) {
        return false;
    }

    return true;
}

function verifyName(name) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return !re.test(name);
}

function isValidEmail(email) {
    return verifyEmail(email, 0);
}

function verifyCampaignUserEmail( formName ){
	/*verify external campaing*/
	if (typeof(formID) == 'undefined') {
        formID = formName;
    }
    var userData = SendFormDataByAjaxRunMethodSync(formID, 'TemporaryCampaignExternal', 'ctUserVerifyEmailCampaign');
    var objTemporaryCampaing = jQuery.parseJSON( userData );
    if ( objTemporaryCampaing != null ){
    	if ( objTemporaryCampaing.Message == 'renaultduster' ){
    		var testABvariation = '';
    		Pop.open('deliveryTime', 'User/' + 'RegisterLogin', create_request_string('FormRegister'), 'default', {'onClose':null});
            void(0);
            return;
        }
    }
    /*END verify external campaing*/
}

function checkEmail(email) {
	verifyCampaignUserEmail('FormRegister');
    var data = 'txEmail=' + email + '&jsonReturn=1';
    var result = SendDataByAjaxRunMethodSync(data, 'Validate', 'checkEmail');
    var objResult = eval(result);
    var returnToURL;

    // if (typeof(objResult[0]) == 'object' && objResult[0].Message == -9999) {
    //     document.location.href = '/ego/';
    //     return result;
    // }

    var $returnToURL = jQuery('#ReturnToURL');

    if ($returnToURL.length) {
        returnToURL = $returnToURL.val();
    } else {
        returnToURL = jQuery('[name=ReturnToURL]').val();
    }

    if (typeof(objResult[0]) == 'object' && (objResult[0].Message == -106 || objResult[0].Message == -100)) {
        if (!returnToURL) {
            returnToURL = '/';
        }

        if( jQuery('[name=isPopRegister]').val() == 1 ){
        	Register.isPopRegister = true;
        }else{
        	Register.isPopRegister = false;
        }

        Login.pop(returnToURL, '', 1, '', '', 1);
        return result;
    }
    return result;
}

function isEmail(email) {
    return verifyEmail(email, 1);
}

function verifyEmail(email, onlyIsValid) {
    var data = 'txEmail=' + email + '&jsonReturn=1';
    if (typeof(onlyIsValid) == 'undefined' || !onlyIsValid) {
        data += '&alreadyExistsError=1';
    }

    var result = SendDataByAjaxRunMethodSync(data, 'Validate', 'isRegistered');

    return result;
}

function sajax_debug(text) {
    if (sajax_debug_mode)
        alert(text);
}

function sajax_init_object() {
    var A;
    var msxmlhttp = new Array(
            'Msxml2.XMLHTTP.5.0',
            'Msxml2.XMLHTTP.4.0',
            'Msxml2.XMLHTTP.3.0',
            'Msxml2.XMLHTTP',
            'Microsoft.XMLHTTP');
    for (var i = 0; i < msxmlhttp.length; i++) {
        try {
            A = new ActiveXObject(msxmlhttp[i]);
        } catch (e) {
            A = null;
        }
    }

    if (!A && typeof XMLHttpRequest != "undefined")
        A = new XMLHttpRequest();
    if (!A)
        sajax_debug("Could not create connection object.");
    return A;
}

var sajax_requests = new Array();

function sajax_cancel() {
    for (var i = 0; i < sajax_requests.length; i++) {
        sajax_requests[i].abort();
    }

    return true;
}

function sajax_do_call(func_name, args) {

    var i, x, n, uri, post_data;
    var target_id = sajax_target_id;
    var callback_function;


    if (typeof(sajax_request_type) == "undefined" || sajax_request_type == "")
        sajax_request_type = "GET";

    uri = sajax_uri;
    if (sajax_request_type == "GET") {

        if (uri.indexOf("?") == -1)
            uri += "?rs=" + escape(func_name);
        else
            uri += "&rs=" + escape(func_name);
        uri += "&rst=" + escape(sajax_target_id);
        uri += "&rsrnd=" + new Date().getTime();

        for (i = 0; i < args.length - 1; i++)
            uri += "&rsargs[]=" + escape(args[i]);

        post_data = null;
    }
    else if (sajax_request_type == "POST") {
        post_data = "rs=" + escape(func_name);
        post_data += "&rst=" + escape(sajax_target_id);
        post_data += "&rsrnd=" + new Date().getTime();

        if (args != null) {
            //alert(args.length);
            //for (i = 0; i < args.length-1; i++){
            for (i = 0; i < args.length; i++) {
                if (typeof args[i] === 'function') {
                    callback_function = args[i];
                } else {
                    post_data = post_data + "&rsargs[]=" + escape(args[i]);
                }
            }
        }

        post_data += '&ajaxcall=1';
    }
    else {
        alert("Illegal request type: " + sajax_request_type);
    }

    x = sajax_init_object();
    if (x == null) {
        sajaxErrMessage();

        if (sajax_failure_redirect != "") {
            location.href = sajax_failure_redirect;
            return false;
        } else {
            sajax_debug("NULL sajax object for user agent:\n" + navigator.userAgent);
            return false;
        }
    } else {
        x.open(sajax_request_type, uri, sajax_async_mode);
        if (sajax_request_type == "POST") {
            x.setRequestHeader("Method", "POST " + uri + " HTTP/1.1");
            x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        }
        if (sajax_async_mode) {
            x.onreadystatechange = function() {
                if (x.readyState != 4)
                    return;
                escondeLoader();
                sajax_debug("received " + x.responseText);
                var status;
                var data;
                var txt = x.responseText.replace(/^\s*|\s*$/g, "");

/*                while( txt.indexOf('\\n') > -1 || txt.indexOf('\\"') > -1 ) {
                    txt = txt.replace('\\n' , "").replace('\\r', "" );
                }*/

                /*for (aux = 1; aux < 10; aux++) {
                    txt = txt.replace(/^\n/, "");
                    txt = txt.replace(/^\r/, "");
                }*/
                status = txt.charAt(0);
                data = txt.substring(2);
                if (status != '' && status != '-') {
                    if (target_id != "") {
                        document.getElementById(target_id).innerHTML = eval(data);
                    } else {
                        try {
                            var callback;
                            var extra_data = false;
                            if (typeof args[args.length - 1] == "object") {
                                callback = args[args.length - 1].callback;
                                extra_data = args[args.length - 1].extra_data;
                            } else {
                                callback = args[args.length - 1];
                            }

                            try {
                                var testDataIsJson = jQuery.parseJSON(data);

                                data = testDataIsJson;

                                if (typeof(data.isError) != 'undefined') {
                                    if (callback_function) {
                                        callback_function(data);
                                        return;
                                    } else if (typeof data.callback != 'undefined') {
                                        data.callback(data);
                                        return;
                                    }

                                    //call the feedback class
                                    Feedback.alert(data);

                                    if (popCurrent != null && (typeof(data.Stop) != 'undefined') && data.Stop) {
                                        popCurrent.close();
                                    }

                                    return;
                                }
                            } catch(e) {

                            }

/*                            if (data.isJSON()) {
                                data = data.evalJSON();

                                if (typeof(data.isError) != 'undefined') {
                                    if (typeof(data.callback) != 'undefined') {
                                        data.callback(data);
                                        return;
                                    }

                                    //call the feedback class
                                    Feedback.alert(data);

                                    if (popCurrent != null && (typeof(data.Stop) != 'undefined') && data.Stop) {
                                        popCurrent.close();
                                    }

                                    return;
                                }
                            }*/

                            //return;

                            try {
                                callback(eval(data), extra_data);

                            } catch (e) {
                                callback(data, extra_data);
                            }

                        } catch (e) {
                            //sajaxErrMessage();
                            sajax_debug("Caught error " + e + ": Could not eval " + data);
                        }

                        //alert('aqui');
                    }
                }

                setTimeout("escondeLoader()", 3000);

                return true;
            }
        }
    }

    if (enable_load) {
        mostraLoader()
    } else {
        enable_load = true
    }
    x.send(post_data);


    if (!sajax_async_mode) {
        var timeoutID;
        timeoutID = setTimeout("sajax_cancel();", sajax_wait);

        var data;
        var txt = x.responseText.replace(/^\s*|\s*$/g, "");

        for (aux = 1; aux < 10; aux++) {
            txt = txt.replace(/^\n/, "");
            txt = txt.replace(/^\r/, "");
        }

        status = txt.charAt(0);
        data = txt.substring(2);

        if (timeoutID) {
            window.clearTimeout(timeoutID);
        }

        if (data.isJSON()) {
            data = data.evalJSON();

            if (typeof(data.isError) != 'undefined') {
                if (typeof(data.callback) != 'undefined') {
                    data.callback(data);
                    return;
                }

                //call the feedback class
                Feedback.alert(data);
                return void(0);
            }
        }

        // Boolean return
        if (data.indexOf('var res') != -1) {
            data = eval(data);
        }

        return data;
    }

    //sajax_debug(func_name + " waiting..");
    delete x;
    return true;
}

function sajaxErrMessage() {
    alert('Ocorreu um erro desconhecido na comunicação com o servidor. Por favor tente realizar a ação novamente. Caso esta mensagem apareça novamente, verifique a sua conexão com a internet.');
}

// wrapper for ReceiveFormDataByAjaxRunMethod
function x_ReceiveFormDataByAjaxRunMethod() {
    sajax_do_call("ReceiveFormDataByAjaxRunMethod", arguments);
}


// wrapper for ReceiveFormDataByAjaxRunTemplate
function x_ReceiveFormDataByAjaxRunTemplate() {
    sajax_do_call("ReceiveFormDataByAjaxRunTemplate", arguments);
}

// wrapper for ReceiveFormDataByAjaxRunTemplate
function x_ReceiveFormDataByAjaxRunTemplateSync() {
    return sajax_do_call("ReceiveFormDataByAjaxRunTemplate", arguments);
}

function x_ReceiveFormDataByAjaxRunMethodSync() {
    return sajax_do_call("ReceiveFormDataByAjaxRunMethod", arguments);
}


function pageRedirect(redirectTo) {

    if (typeof(redirectTo) == 'undefined' || redirectTo == '' || ascii_value(redirectTo.charAt(0)) == 0) {
        document.location.reload();
        return void(0);
    }
    document.location.href = redirectTo;

}

function pageReload() {
    document.location.reload();
}

function isChecked(element) {
    return false;
}

function isEmpty(element) {

    if (typeof(element.value) != 'undefined') {
        return !element.value.blank();
    }

    return !element.blank();
}

function isEmptyFormSurveyRadio() {

    var valueRadio = valueInputRadio('FormSurvey', 'rdSurveyAnswer');

    if (valueRadio != '') {
        return true;
    }

    return false;
}

function verifyLoginPOP() {
    return verifyLogin('FormPOPLogin', false);
}

function verifyLogin(formID, defaultFormLogin) {
    if (typeof(defaultFormLogin) == 'undefined') {
        formID = 'FormLogin';
    } else {
        if (defaultFormLogin) {
            formID = defaultFormLogin.id;
        }
    }

    var data = create_request_string(formID);
    var result = SendDataByAjaxRunMethodSync(data, 'Validate', 'login');

    objResult = eval(result);

    // if (typeof(objResult[0]) == 'object' && objResult[0].Message == -9999) {
    //     document.location.href = '/ego/';
    //     return result;
    // }

    return result;
}

function verifyPassword(password) {
    if (password.length > 12 || password.length < 4) {
        return false;
    }

    return true;
}

function verifyGender(gender) {
    var value = gender.value;
    if (typeof(value) == 'undefined') {
        value = gender;
    }

    if (value == 0) {
        return false;
    }

    if (value != 1 && value != 2) {
        return false;
    }

    return true;
}

function verifyBirthTime(birthTime) {
    if (!birthTime) {
        return false;
    }

    var auxbirthTime = birthTime.split(':');
    if (auxbirthTime[0] == '') {
        return false;
    }

    if (auxbirthTime[1] == '') {
        return false;
    }

    if (auxbirthTime[0] > 23 && auxbirthTime[0] < 0) {
        return false;
    }

    if (auxbirthTime[1] > 59 && auxbirthTime[1] < 0) {
        return false;
    }

    return true;
}

function verifyCountry(country, form) {
    return true;
}

function verifyEstate(estate, form) {
    return true;
}

function verifyCity(city, form) {
    var country = encodeURIComponent(form.elements['ddCountry'].value);
    var estate = encodeURIComponent(form.elements['ddEstate'].value);

    if (estate == 28) { // ALL
        estate = 0;
    }

    var data = 'countryID=' + country + '&estateID=' + estate + '&cityName=' + encodeURIComponent(city);
    var result = SendDataByAjaxRunMethodSync(data, 'Validate', 'verifyCity');

    return result;
}

function verifyNameIndications(names) {
    var form = document.getElementById('FormIndication');
    var elements = form.elements['txDestinationName[]'];

    if (typeof(elements.length) == 'undefined') {
        elements = [elements];
    }

    for (var i = 0; i < elements.length; i++) {
        if (elements[i].value == '') {
            return false;
        }
    }

    return true;
}

function verifyEmailIndications(emails) {
    var form = document.getElementById('FormIndication');
    var elements = form.elements['txDestinationEmail[]'];

    if (typeof(elements.length) == 'undefined') {
        elements = [elements];
    }

    for (var i = 0; i < elements.length; i++) {
        if (elements[i].value == '') {
            return false;
        }
    }

    return true;
}

function forgotPasswordCheckEmail(email) {
    var data = create_request_string('FormForgotPassword') + '&alreadyExistsError=0';
    var result = SendDataByAjaxRunMethodSync(data, 'Validate', 'isRegistered');

    return result;
}

function StartPage(obj) {
    objPageParams = obj;
}

/**
 *
 * @param String template Template responsável por receber o bloco html com os dados já tratados.
 * @param QueryString extraData Receberá da variável de inicialização AjaxData uma QueryString com os campos de parâmetro de busca do formulário
 * @param boolean goToTop Parâmentro responsável por definir se ao recarregar a template ocorrerá do formulário se posicionar no topo
 * @param boolean disableLoading Parâmetro responsável por desabilitar/habilitar um modal de carregando enquanto a função é executada.
 * @param boolean history Define o tipo de chamada assíncrona que será realizada
 * @return StringHTML
 */
function Refresh(template, extraData, goToTop, disableLoading, history) {

    if (typeof(disableLoading) != 'undefined' && disableLoading) {
        enable_load = false;
    }

    if (typeof(history) != 'undefined' && !history) {
        history = false;
    } else {
        history = true;
    }

    if (history) {
        SendDataByAjaxRunTemplateHistory(template, extraData, SetDivContent)
    } else {
        SendDataByAjaxRunTemplate(template, extraData, SetDivContent)
    }


    if (typeof(goToTop) != 'undefined' && goToTop) {
        window.scrollTo(0, goToTop);
    }
}

/**** PROFILE ****/
var Profile = {
	'params': [],
	'dontHaveUserBeforeLogin': false,
    'isToRedirect': true,
    'dontUseProfile': {
        1: {'url': '/astrologia/horoscopo'},
        10: {'url': '/tarot/tarot-e-o-amor'},
        11: {'url': '/tarot/tarot-semestral'},
        14: {'url': '/runas/runas-e-vida-material'},
        15: {'url': '/tarot/tarot-do-dia/jogar'},
        12: {'url': '/oraculos/i-ching/jogar'},
        20: {'url': '/tarot/tarot-mensal'}
    },
    /**
     * Redireciona o usuario caso esteja logado no sistema
     * @param path - (url)
     * @return boolean
     * */
    'redirectUser': function(path){
    	if( (typeof(GetCookie('UC')) == 'string') && (GetCookie('UC') != "0") ){
			document.location.href = path;
			return true;
    	}else{
    		return false;
    	}
    },
    /**
     * Checa se o usuario caso esteja logado no sistema
     * @return boolean
     * */
    'checkUserLogged': function(){
    	if( (typeof(GetCookie('UC')) == 'string') && (GetCookie('UC') != "0") ){
    		Profile.dontHaveUserBeforeLogin = false;
    		return true;
    	}else{
    		Profile.dontHaveUserBeforeLogin = true;
    		return false;
    	}
    },
    /**
     * Verifica se a página atual está autorizada a exibir o popup de seleção de perfil
     * para um produto
     * @return boolean
     * */
    'checkCurrentPageAllowedToSelectProfileProduct': function(){
        var notAllowed = ['/cadastro/obrigado'];
        var currentPath = window.location.pathname;
        for(var i = 0; i < notAllowed.length; i++) {
            if(notAllowed[i] == currentPath) {
                return false;
            }
        }
        return true;
    },
    /**
     * Checa se o usuario se logou atraves de uma pop de selecao de perfil
     * @return boolean
     * */
    'checkSelectProfileProductIDBeforeLogin': function(){
    	if( (Profile.checkUserLogged()) === true && (typeof(GetCookie('isSelectProfileProductIDBeforeLogin')) == 'string') && (GetCookie('isSelectProfileProductIDBeforeLogin') != "0") ){
    		return true;
    	}else{
    		return false;
    	}
    },
    /**
     * Retorna o id do produto que o usuario se logou atraves da pop de selecao de perfil
     * @return String
     * */
    'getLastSelectProfileProductID': function(){
    	return GetCookie('isSelectProfileProductIDBeforeLogin');
    },
    /**
     * Seta o id do produto que o usuario se logou atraves da pop de selecao de perfil
     * @return String
     * */
    'setSelectProfileProductIDBeforeLogin': function(productID){
    	if( Profile.dontHaveUserBeforeLogin === true ){
    		SetCookie('isSelectProfileProductIDBeforeLogin', productID);
    	}
    },
    /**
     * Funcao para checar o tipo de selecao de perfil
     * */
    'checkTypeSelectProduct': function(productID,itemCartCode){
    	var path = '';
    	if (typeof(Profile.dontUseProfile[productID]) != 'undefined' && ( typeof(itemCartCode) == 'undefined' && itemCartCode != '') ){
        	path = Profile.dontUseProfile[productID]['url'];
            if (productID == 15){
                document.location.href = path;
                return false;
            }
            if (productID != 12 && productID != 1){
        		path = Profile.dontUseProfile[productID]['url'] + '/mini/jogar';
                SetCookie('returnToURL', path);
        	}
            if(Profile.redirectUser(path) === true){
            	return false;
            }else{
            	Login.isRedirectToURLAfterLogin = true;
            	Profile.params.push('returnToURL=' + path);
            	Profile.params.push('ReturnToURL=' + path);
            	return true;
            }
        }else{
        	Profile.setSelectProfileProductIDBeforeLogin(productID);
        	return true;
        }
    },
    'select': function (productID, itemCartCode, callback, profileID, addClass, alertError, redirectAfterSelectProfile) {
    	Profile.checkUserLogged();
        if(Profile.checkTypeSelectProduct(productID,itemCartCode) == true){
	        Profile.params.push('ProductID=' + productID);
	        if (typeof(itemCartCode) != 'undefined' && itemCartCode != '') {
	        	Profile.params.push('ItemCartCode=' + itemCartCode);
	        }
	        if (typeof(profileID) != 'undefined' && profileID > 0) {
                Profile.params.push('ProfileID=' + profileID);
            }
            if (typeof(alertError) != 'undefined' && alertError != '') {
	        	Profile.params.push('alertError=' + alertError);
	        }
            if (typeof(addClass) != 'undefined' && addClass != '' && typeof(addClass) != 'object') {
                Profile.params.push('addClass=' + addClass);
            }
            if (typeof(redirectAfterSelectProfile) == 'boolean') {
                Profile.isToRedirect = redirectAfterSelectProfile;
            }
	        Pop.open(
		        'selectProfile',
		        'Profile/SelectProfile',
		        Profile.params.join('&'), 'default', {'onClose': null, 'onComplete': {'method': callback, 'args': [productID, itemCartCode]}}
	        );
        }
        return;
    },
    'edit': function (profileID, itemCartCode, callback, addClassToPop ) {
        var params = ['ProfileID=' + profileID, 'Option=Edit'];
        if (typeof(itemCartCode) != 'undefined' && itemCartCode != '') {
            params.push('ItemCartCode=' + itemCartCode);
        }
        if (typeof(addClassToPop) != 'undefined' && addClassToPop != '' && typeof(addClassToPop) != 'object') {
            params.push('addClass=' + addClassToPop);
        }
        if (!callback) {
            if (popCurrent != null) {
                callback = {'onComplete': {'method': popCurrent.close, 'args': null}}
            } else {
                callback = {};
            }
        }
        //se eu nao tenho um perfil selecionado exibo esta msg.
        if (profileID == "" || typeof(profileID) == 'undefined') {
            alert(utf8_decode('Olá, você ainda precisa selecionar o perfil.'));
        } else {
            Pop.open(
                    'editProfile',
                    'Profile/EditProfile',
                    params.join('&'),
                    'default', callback
                    );
            return void(0);
        }
    },
    //TODO needs refactoring
    'editByShopping': function ( profileID, itemCartCode, callback , ReturnToUrl, addClass ){
    	var params = ['ProfileID=' + profileID, 'Option=Edit'];
        if (typeof(itemCartCode) != 'undefined' && itemCartCode != '') {
            params.push('ItemCartCode=' + itemCartCode);
        }
        if (typeof(ReturnToUrl) != 'undefined' && ReturnToUrl != '') {
            params.push('ReturnToUrl=' + ReturnToUrl);
        }
        if (typeof(addClass) != 'undefined' && addClass != '') {
            params.push('addClass=' + addClass);
        }
        if (!callback) {
            if (popCurrent != null) {
                callback = {'onComplete': {'method': popCurrent.close, 'args': null}}
            } else {
                callback = {};
            }
        }
        //se eu nao tenho um perfil selecionado exibo esta msg.
        if (profileID == "" || typeof(profileID) == 'undefined') {
            alert(utf8_decode('Olá, você ainda precisa selecionar o perfil.'));
        } else {
            Pop.open(
                    'editProfile',
                    'Profile/EditProfile',
                    params.join('&'),
                    'default', callback
                    );
            return void(0);
        }
    },
    'checkOption': function (event, itemCartCode) {
        var $ddProfile = jQuery(event.target);
        var ddProfileId = $ddProfile.attr('id');
        if (( $ddProfile.val() == 'AddProfile' ) && ( ddProfileId == 'ddProfile1' || ddProfileId == 'ddProfile2' )) {
            Cookie.remove('ddProfile1');
            Cookie.remove('ddProfile2');

            var cookieName = ddProfileId;

            if (ddProfileId == 'ddProfile1') {
                var cookieName = '#ddProfile2';
            } else {
                var cookieName = '#ddProfile1';
            }

            var cookieValue = jQuery(cookieName).val();

            if (!cookieValue.length) {
                cookieValue = 'Selecione';
            }

            //Adiciona um cookie para marcar qual o dropdown o usuário selecionou primeiro
            Cookie.add(cookieName, cookieValue, false, '/');

        }

        switch ($ddProfile.val()) {

            case 'AddProfile':
                Profile.create(itemCartCode);
                break;

            default:
                break;

        }


        return void(0);

    },

    'create': function (itemCartCode, callback) {
        var params = ['Option=Add'];
        if (typeof(itemCartCode) != 'undefined' && itemCartCode != '') {
            params.push('ItemCartCode=' + itemCartCode);
        }

        if (typeof(callback) == 'undefined' || callback == null) {
            callback = {'onComplete': {'method': popCurrent.close, 'args': ''}};
        }

        Pop.open(
                'addprofile',
                'Profile/EditProfile',
                params.join('&'),
                'default', callback
                );

        return void(0);
    },

    'returnEditProfile': function (result, profileID) {
        if (result > 0) {

            if (profileID <= 0) {
                profileID = result;
                SetCookie('EDITPROFILE',profileID,0);
            }

            if (popCurrent.getParent() != null) {
                popCurrent.getParent().properties.params += '&ProfileID=' + profileID;
                popCurrent.getParent().open();
                popCurrent.close();
                return void(0);
            }

            if (typeof(popCurrent.onCompleteMethod) != 'undefined') {
                popCurrent.complete(result);
                popCurrent.close();
            }
        }
        //escondeLoader();
    },

    'returnSaveProfile': function (result) {
        if (result == 'ADMIN_OK') {
            alert("O produto foi editado!\nFeche a janela e volte ao relatório.");
            popCurrent.close();
            history.go(-2);
        }
        if (!(result instanceof Object)) {
            ReturnSaveProfile(result);
            return true;
        }

        var urlProductMini = result.productInfo.urlProductMini + result.code;
        window.location.href = urlProductMini;
    },

	/**
	 * Função para editar a hora de nascimento de um perfil.
	 * @param int $profileID
	 * @param int $birhTime
	 * @return boolean
	 */
	'editBirthTime': function (profileID,birthTime){

	  if( profileID == '' || typeof(profileID) == 'undefined' || profileID == null ){
		  return false;
	  }

	  if( birthTime == '' || typeof(birthTime) == 'undefined' || birthTime == null ){
		  return false;
	  }

	  var result = SendDataByAjaxRunMethodSync('&profileID='+profileID+'&birthTime='+birthTime, 'Profile', 'editBirthTime');

	  return result;

	},

    /**
     * Função para adicionar um produto com os perfis selecionados de um destque ao carrinho
     * @param int profile1ID
     * @param int profile2ID
     * @param int offerID
     * @return para url do carrinho com a analise ja com os perfis
     */
    'sinastryAddProfileCart': function (profile1ID, profile2ID, offerID) {
        if (profile1ID == '' || typeof(profile1ID) == 'undefined' || profile1ID == null) {
            return false;
        }
        if (profile2ID == '' || typeof(profile2ID) == 'undefined' || profile2ID == null) {
            return false;
        }
        if (offerID == '' || typeof(offerID) == 'undefined' || offerID == null) {
            return false;
        }
        var data = 'Profile1ID=' + profile1ID + '&Profile2ID=' + profile2ID;
        var result = SendDataByAjaxRunMethodSync(data, 'SinastryChart', 'SaveProfileMini');
        if (result['code'] == '' || typeof(result['code']) == 'undefined' || result['code'] == null) {
            alert('Ocorreu um erro inesperado.');
            return false;
        } else {
            returnUrl = '/carrinho/adicionar/' + offerID + '?CreatedProductCode=' + result['code'];
            document.location.href = returnUrl;
            return void(0);
        }
        return false;

    },

    /**
     * Função para gerar um mini de sinastria
     * @param int profile1ID
     * @param int profile2ID
     * @return para url do mini
     */
    'sinastryCreateMini': function (profile1ID, profile2ID) {
        if (profile1ID == '' || typeof(profile1ID) == 'undefined' || profile1ID == null) {
            return false;
        }
        if (profile2ID == '' || typeof(profile2ID) == 'undefined' || profile2ID == null) {
            return false;
        }
        var data = 'Profile1ID=' + profile1ID + '&Profile2ID=' + profile2ID;
        var result = SendDataByAjaxRunMethodSync(data, 'SinastryChart', 'SaveProfileMini');
        if (result['code'] == '' || typeof(result['code']) == 'undefined' || result['code'] == null) {
            alert('Ocorreu um erro inesperado.');
            return false;
        } else {
            returnUrl = '/astrologia/sinastria-amorosa/mini/' + result['code'];
            document.location.href = returnUrl;
            return void(0);
        }
        return false;
    },

    /**
     * Função para adicionar um produto Mapa Astral com os perfis selecionados de um destque ao carrinho
     * @param int profileID
     * @param int offerID
     * @return para url do carrinho com a analise ja com os perfis
     */
    'natalChartAddProfileCart': function (profileID, offerID, isGift) {
    	if (profileID == '' || typeof(profileID) == 'undefined' || profileID == null) {
    		return false;
    	}
    	if (offerID == '' || typeof(offerID) == 'undefined' || offerID == null) {
    		return false;
    	}
    	if (isGift == '' || typeof(isGift) == 'undefined' || isGift == null) {
    		var isGift = 0;
    	}
    	var data = 'ProfileID=' + profileID;
    	var result = SendDataByAjaxRunMethodSync(data, 'NatalChart', 'SaveProfileAddCart');
    	if (result['code'] == '' || typeof(result['code']) == 'undefined' || result['code'] == null) {
    		alert('Ocorreu um erro inesperado.');
    		pageReload();
    	} else {
    		if(isGift == 1){
    			returnUrl = '/carrinho/adicionar/' + offerID + '?CreatedProductCode=' + result['code'] + '&svGift=2';
    		}else{
    			returnUrl = '/carrinho/adicionar/' + offerID + '?CreatedProductCode=' + result['code'];
    		}
    		document.location.href = returnUrl;
    		return void(0);
    	}
    	return false;

    }
};
//-----END PROFILE

function verifyFormIndication() {
    var result = SendFormDataByAjaxRunMethodSync('FormIndication', 'Validate', 'indicationForm');
    return result;
}

var Indication = {
    'types': {
        'Product': 1,
        'Link': 2
    },

    'feedbackTitleHeader': '' ,
    'feedbackTitle': '' ,
    'feedbackMessage': '' ,

    'open': function (url, type, title, feedbackTitle, feedbackMessage, feedbackTitleHeader) {
        var params = ['URL=' + escape(url), 'Type=' + type];

        if (typeof(title) != 'undefined') {
            params.push('Title=' + title);
        }

        if (typeof(feedbackTitleHeader) != 'undefined') {
            Indication.feedbackTitleHeader = feedbackTitleHeader;
        }
        else {
            Indication.feedbackTitleHeader = utf8_decode('indicação');
        }

        if (typeof(feedbackTitle) != 'undefined') {
            Indication.feedbackTitle = feedbackTitle;
        }
        else {
            Indication.feedbackTitle = utf8_decode('Sua indicação foi realizada com sucesso.');
        }

        if (typeof(feedbackMessage) != 'undefined') {
            Indication.feedbackMessage = feedbackMessage;
        }
        else {
            Indication.feedbackMessage = utf8_decode('Fique à vontade e continue navegando pelo Personare.');
        }


        Pop.open(
                'indicationForm',
                'Indication/Pop/Form',
                params.join('&'),
                'default', {}
                );
    },

    'formValidate': function () {
        alert();
    },
    'send': function (sendResult) {
        if (typeof(sendResult) != 'undefined') {
            if (Boolean(sendResult)) {
                popCurrent.close();
                Feedback.pop(utf8_encode(Indication.feedbackTitleHeader), utf8_encode(Indication.feedbackTitle), utf8_encode(Indication.feedbackMessage), 0);
                return true;
            }
            return false;
        }
        SendFormDataByAjaxRunMethod('FormIndication', 'Indication', 'SendIndication', Indication.send);
    },
    'addRecipient': function () {
        var recipients = jQuery('.recipient');
        var newRecipient = recipients.last().clone()[0];
        var auxID = '';
        var inputs = newRecipient.getElementsByTagName('input');
        for (var i = 0; i < inputs.length; i++) {
            auxID = (i == 0) ? 'Name' : 'Email';
            inputs[i].id = 'indication' + auxID + (recipients.length + 1);
            inputs[i].value = '';

            jQuery(document).delegate(inputs[i], 'focus blur', function(e) {
                if (event.type == 'focus') {
                    PatternForm.ManageInput.focus(this, '');
                } else {
                    PatternForm.ManageInput.blur(this, '');
                }
            });
        }

        var labels = newRecipient.getElementsByTagName('label');
        for (var i = 0; i < labels.length; i++) {
            auxID = (i == 0) ? 'Name' : 'Email';
            labels[i].id = 'indication' + auxID + (recipients.length + 1) + '_Label';
            jQuery(labels[i]).attr('for', 'indication' + auxID + (recipients.length + 1));
        }

        jQuery(newRecipient).appendTo('#recipients');
    }
};

//javascript:FriendsList.linkTo('Profile.select',%20'javascript:',%202188428,%20[16,null,null]);
var FriendsList = {
    'openedfriends': {},
    'refreshArgs': {},

    'refresh': function () {

        if (popCurrent != null) {
            popCurrent.close();
        }

        var data = 'Title=' + utf8_encode(FriendsList['refreshArgs']['Title']) + '&LinkTo[Action]=' + FriendsList['refreshArgs']['LinkTo']['Action'] + '&LinkTo[Type]=' + FriendsList['refreshArgs']['LinkTo']['Type'] + '&LinkTo[Params]=' + FriendsList['refreshArgs']['LinkTo']['Params'];
        //SendDataByAjaxRunTemplate(FriendsList['refreshArgs']['TEMPLATE'], data, SetDivContent);
        SendDataByAjaxRunTemplate(FriendsList['refreshArgs']['TEMPLATE'], data, function(content) {
			jQuery('#user_friendslist').html(content);
            if ( jQuery('#user_mainfriendslist')[0] ) {
			   jQuery('#user_mainfriendslist').html(content);
			} else {
				jQuery('#user_friendslist').html(content);
			}
        });

    },

    'linkTo': function (target, type, profile, params) {
        switch (type) {
            case 'JS':
                target.apply(this, [profile]);
                break;

            case 'javascript:':
                params.push(profile);
                target = eval(target);
                target.apply(this, params);
                return;

            case 'LNK':
                document.location.href = target;
                return;

                break;

            default:
                document.location.href = target + '/amigo/' + encodeUser(profile);
        }

        return void(0);
    },

    'viewProfile': function (profileID) {
        var $link = jQuery('#Folder_link_' + profileID);
        var $row = $link.parent().parent();
        if (typeof(FriendsList.openedfriends[profileID]) != 'undefined') {
            SetDivContent('', 'friend' + profileID);
            delete(FriendsList.openedfriends[profileID]);
            $row.removeClass('active');
            $link.removeClass('collapse').addClass('expand');
            return;
        } else {

            var data = 'ProfileID=' + profileID;
            SendDataByAjaxRunTemplate('User/FriendData', data, function (content) {
                FriendsList.openedfriends[profileID] = 1;
                SetDivContent(content, 'friend' + profileID);
            });

            $row.addClass('active');
            $link.addClass('collapse').removeClass('expand');

        }
    },

// callbackLinkto: Especifica uma função de callback que será executada após o perfil ter sido adicionado com sucesso

    'addFriend': function (showTransit, callbackLinkto, returnToURL) {

        var callback = FriendsList.refresh;

        if (typeof(showTransit) != 'undefined' && showTransit) {
            callback = function (profile) {
                FriendsList.linkTo('/astrologia/horoscopo', 'LNK', profile);
            };
        }

        if (typeof(returnToURL) != 'undefined' && returnToURL) {
        	callback = function (profile) {
        		FriendsList.linkTo(returnToURL, 'LNK', profile);
        	};
        }

        if (typeof(callbackLinkto) != 'undefined' && callbackLinkto) {
            callback = callbackLinkto;
        }

        Profile.create(null, {
            'onComplete': {'method': callback, 'args': []}
        });
    },

    'editFriend': function (profile) {
        Profile.edit(
                profile, null,
        {'onComplete': {'method': FriendsList.refresh, 'args': null}}
                );
    },

    'removeFriend': function (profile) {
        var data = 'ProfileID=' + profile;
        SendDataByAjaxRunMethod(data, 'Profile', 'removeProfile', FriendsList.removeFriendResult);
    },

    'removeFriendResult': function (result) {
        if (result > 0) {
            if (popCurrent != null) {
                Pop.close();
            }
            FriendsList.refresh();
        }
    }
};

var Dialog = {
    'question': function (title, question, action) {
        var data = 'Title=' + title + '&Question=' + question + '&Action=' + action;
        Pop.open(
                'dialog', 'Pattern/Pop/Dialog', data, 'default', {}
                );
    }
};

var CreatedProduct = {
    'delete': function (callback, params, isQuery) {
    	var objSystemLog = new SystemLog({
			id : null,
			title : 'Funcao deletar analise',
			action : 'Chamada da funcao para abrir Pop',
			typelogid : 2,
			identificationCode : 3333
		});
    	objSystemLog.date = objSystemLog.getToday();
    	objSystemLog.user = objSystemLog.processUC();
    	objSystemLog.newdata = JSON.stringify(objSystemLog.parseQueryString(params));
    	objSystemLog.setLog();

        if (typeof(callback) != 'function') {
            callback = window[callback];
        }
        Pop.open(
            'dialog', 'CreatedProduct/Pop/DeleteProduct', params, 'default', {
            'onComplete': {'method': callback, 'args': params}
            }
        );
    }
};

var Cookie = {
    'add': function (name, value, expires, path, domain, secure) {
        // set time, it's in milliseconds
        var today = new Date();
        today.setTime(today.getTime());

        /*
         if the expires variable is set, make the correct
         expires time, the current script below will set
         it for x number of days, to make it for hours,
         delete * 24, for minutes, delete * 60 * 24
         */
        if (expires) {
            expires = expires * 1000 * 60 * 60 * 24;
        }

        var expires_date = new Date(today.getTime() + (expires));

        document.cookie = name + "=" + escape(value)
                + ((expires) ? ";expires=" + expires_date.toGMTString() : "")
                + ((path) ? ";path=" + path : "")
                + ((domain) ? ";domain=" + domain : "")
                + ((secure) ? ";secure" : "" );

        return void(0);
    },

    'get': function (name) {
        var start = document.cookie.indexOf(name + "=");
        var len = start + name.length + 1;

        if ((!start) && (name != document.cookie.substring(0, name.length))) {
            return null;
        }

        if (start == -1) {
            return null;
        }

        var end = document.cookie.indexOf(";", len);
        if (end == -1) {
            end = document.cookie.length;
        }

        return unescape(document.cookie.substring(len, end));
    },

    'remove': function (name, path, domain) {
        if (Cookie.get(name)) {
            document.cookie = name + "="
                    + ((path) ? ";path=" + path : "")
                    + ((domain) ? ";domain=" + domain : "")
                    + ";expires=Thu, 01-Jan-1970 00:00:01 GMT";
        }
    }
};

/**
 * Funcao para mapear eventos de uma pagina usando o Google Analytics
 * */
function fwTrackEventActions(category,action,label){
    if (typeof ga !== 'undefined') {
        ga('send', 'event', category, action, label);
    }
	return true;
}

/**
 *Função Login.pop
 *
 *    Nesta função temos a pop de login do personare.
 *    Parametros:
 *    -returnToURL: especifica a url de retorno assim que e executada alguma acao do usuario.
 *    -encoded:
 *    -hasClose:
 *    -loginSell: identifica o caminho da slice que deve ser chamada para um conteudo excluisivo. Se não tiver nenhum parametro
 *    -loginHeader: identifica o caminho da slice que deve ser chamada para um conteudo excluisivo. Se não tiver nenhum parametro
 *    -loginRegister: identifica o caminho da slice que deve ser chamada para um conteudo excluisivo. Se não tiver nenhum parametro
 *    -params: querystring com os parametros que devem ser passados para a pop de login
 *    passado, ele chama como default a slice User\LoginSell.tpl
 *    OBS: para criar um padrao o nome da slice que vai ser chamada sempre sera LoginSell.tpl
 */

var Login = {
	'enableTrackEvents': true,
	'isRedirectToURLAfterLogin': false,
    'pop': function (returnToURL, encoded, hasClose, loginSell, loginHeader, loginRegister, params, productID, addClass, productName){
        if( Login.enableTrackEvents == true){
        	fwTrackEventActions('Pop-Login', 'Abrir - Pop de Login', 'Abrir - Pop de Login');
        }
    	templatePop = 'User/Login';
        emailAddress = '';
        var isPopRegister = 0,
        data = "";
        if( Register.isPopRegister === true ){
        	isPopRegister = 1;
        	data = create_request_string(Register.FormID);
        }

        if (typeof(encoded) != 'undefined' && encoded != '') {
            returnToURL = base64_decode(returnToURL);
        }

        if (typeof(hasClose) == 'undefined') {
            hasClose = 1;
        }
        if (typeof(loginSell) == 'undefined' || loginSell == '') {
            loginSell = '';
        }
        if (typeof(loginHeader) == 'undefined' || loginHeader == '') {
            loginHeader = '';
        }
        if (typeof(loginRegister) == 'undefined' || loginRegister == '') {
            loginRegister = '';
        } else {
            templatePop = 'User/RegisterLogin';
            emailAddress = jQuery('#E-Mail').val();
        }
        if (typeof(params) == 'undefined' || params == '') {
        	params = '';
        }
        if (typeof(productID) == 'undefined' || productID == '') {
            productID = '';
        }
        if (typeof(addClass) == 'undefined' || addClass == '') {
            addClass = '';
        }
        if (typeof(productName) == 'undefined' || productName == '') {
            productName = '';
        }

        data += '&isPopRegister=' + isPopRegister + '&ReturnToURL=' + returnToURL + '&HasClose=' + hasClose + '&LoginSell=' + loginSell + '&LoginHeader=' + loginHeader + '&emailAddress=' + emailAddress + '&' + params + '&productID=' + productID + '&addClass=' + addClass + '&productName=' + productName;
        Pop.open(
	        'userLogin',
	        templatePop,
	        data,
	        'default', {'onComplete': {'method': pageRedirect, 'args': returnToURL}}
        );
    },

    'efetuaLogin': function (formID) {
        if (typeof(formID) == 'undefined') {
            formID = 'FormLogin';
        }

        var valorTest = jQuery('#'+formID);

        var returnToURL = valorTest.find('[name=ReturnToURL]').val();

        if (returnToURL.length == 0) {
            returnToURL = "/";
        }

        var userCode = SendFormDataByAjaxRunMethodSync(formID, 'User', 'login');

        //verify external campaing
        var userData = SendFormDataByAjaxRunMethodSync(formID, 'User', 'verifyExternalCampaignUser');
        var objTemporaryCampaing = jQuery.parseJSON( userData );
        if ( objTemporaryCampaing != null ){
        	if ( objTemporaryCampaing.Message == 'renaultduster' ){
            	pageRedirect( objTemporaryCampaing.RedirectUrl );
                return;
            }
        }
        //END verify external campaing
        if (userCode > 0) {

            //caso precise redirecionar o usuario para outra pagina apos o login feito na pop
        	if(Login.isRedirectToURLAfterLogin  === true){
        		pageRedirect(returnToURL);
                return;
            //caso recarrego a pagina apos o login feito na pop de selecao
        	}else if( Profile.dontHaveUserBeforeLogin === true && (typeof(GetCookie('NewUserCameFromHolis')) != 'string')){
        		pageRedirect(returnToURL);
                return;
        	}else{
	            try {
	                if (popCurrent && (typeof popCurrent.getParent === 'function') && popCurrent.getParent() != null) {
	                    if (popCurrent.getParent().properties.name == popCurrent.properties.name) {
	                        popCurrent.getParent().getParent().open();
	                        return;
	                    }
	                    popCurrent.getParent().open();
	                    popCurrent.close();
	                    return;
	                }
	            } catch (e) {
	                plog(e);
	            }
	            if (popCurrent == null || popCurrent.getParent() == null){

	                /*if (returnToURL) {
	                    pageRedirect(returnToURL);
	                    return;
	                }*/
	                /*magento login*/
	                var valorTest = jQuery('#'+formID);

	                var $returnToURL = jQuery('input[name=ReturnToURL]').val();

	                var valor;
	                if ($returnToURL.length) {
	                    valor = $returnToURL;
	                } else {

	                    valor = valorTest.find('[name=ReturnToURL]').val();
	                }

	                if (valor) {
	                    var data = 'idUsuario=' + userCode + '&url=' + valor + '&ReturnToURL=' + $returnToURL;
                        valor = SendDataByAjaxRunMethodSync(data, 'User', 'getUserHashId');
                        pageRedirect( valor );
	                    return;
	                }
	                /*magento login*/
	                pageReload();
	                return;
	            }
	            popCurrent.complete();
        	}
        }
    },

    'forgotPassword': function () {
        Pop.open(
                'forgotPassword',
                'User/ForgotPassword',
                '',
                'default', {}
                );
    },

    'sendPassword': function (result) {
    	/*verify external campaing*/

    	if (typeof(formID) == 'undefined') {
            formID = 'FormForgotPassword';
        }
        var userData = SendFormDataByAjaxRunMethodSync(formID, 'TemporaryCampaignExternal', 'ctUserVerifyEmailCampaign');
        var objTemporaryCampaing = jQuery.parseJSON( userData );
        if ( objTemporaryCampaing != null ){
        	if ( objTemporaryCampaing.Message == 'renaultduster' ){
        		var testABvariation = '';
        		//Pop.open('deliveryTime', 'User/' + testABvariation + '/Pop/PopRegisterStep1', create_request_string('FormRegister'), 'default', {'onClose':null});
        		Pop.open('deliveryTime', 'User/' + 'RegisterLogin', create_request_string('FormForgotPassword'), 'default', {'onClose':null});
                void(0);
                return;
            }
        }
        /*END verify external campaing*/

        if (typeof(result) != 'undefined') {
            if (Boolean(result) == true) {
                //popCurrent.close();
                Feedback.pop('Lembrete de Senha', utf8_encode('Lembrete de senha enviado com sucesso.'), utf8_encode('Foi enviado um email com as instruções para redefinir sua senha.'), 1);
            }

            return true;
        }

        SendFormDataByAjaxRunMethod('FormForgotPassword', 'User', 'forgotPassword', Login.sendPassword);
    }
};

var FAQ = {
    'open': function (questionID, isChild) {
        if (isChild == null) {
            var isChild = 0;
        }
        var params = ['QuestionID=' + questionID + '&IsChild=' + isChild];
        Pop.open(
                'faq',
                'FAQ/QuestionsGroup',
                params.join('&'),
                'faq', {'onComplete': {'method': function (e) {
            alert(e);
        }, 'args': ''}}, true
                );
    },
    'openFormMessage': function (questionID) {
        Pop.close();
        window.fcWidget && window.fcWidget.open();
    },
    'loadWidgetFreshdesk': function() {
        var promise = $.getScript("https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.js");
        promise.done(function(data) {
          FreshWidget.init("", {"queryString": "&widgetType=popup&submitThanks=Obrigado+pelo+seu+contato!+Sua+resposta+ser%C3%A1+enviada+em+no+m%C3%A1ximo+48+horas+%C3%BAteis.", "utf8": "✓", "widgetType": "popup", "buttonType": "text", "buttonText": "Suporte", "buttonColor": "white", "buttonBg": "#000374", "alignment": "4", "offset": "235px", "submitThanks": "Obrigado pelo seu contato! Sua resposta será enviada em no máximo 48 horas úteis.", "formHeight": "600px", "url": "https://ajuda.personare.com.br"} );
        });
    },
    'openMagazineFormMessage': function () {
        FreshWidget.show();
    },
    'sendMessage': function () {
        SendFormDataByAjaxRunMethod('FormMessage', 'FAQ', 'sendMessage', FAQ.returnSendMessage);
    },
    'returnSendMessage': function (code) {
        Pop.open(
                'faq_message_feedback',
                'FAQ/FormMessage',
                'Feedback=' + code,
                'default', {'onClose': null}
                );
    },
    'openTutorial': function (groupID, productID, name) {
    	var nameAux = name;
        if (nameAux == null) {
        	nameAux = '';
        }
        var params = ['GroupID=' + groupID + '&ProductID=' + productID + '&name=' + utf8_encode(nameAux)];
        Pop.open(
                'faq',
                'FAQ/Tutorial',
                params.join('&'),
                'video', {'onComplete': {'method': function (e) {
            alert(e);
        }, 'args': ''}}
                );
    },

    'close': function () {
        Pop.close();
    }
};

function remindeBirthTime() {
    var disable = ['ddRememberBirthTimeDays'];
    var form = jQuery('#FormRegister'); // PELO PATTERN EU TENHO ESSA INFORMACAO

    jQuery('#ddRememberBirthTimeDays').attr('disabled', function() {
        return !(jQuery(this).attr('disabled'))
    });

    var noValidate = form.find('#NoValidate_ddBirthTime, [name=NoValidate_ddBirthTime]');

    if (!noValidate.length) {
        createHiddenField('FormRegister', 'NoValidate_ddBirthTime', 1);
    }
}

function dontKnowBirthTime(event) {
    var disable = ['#ddBirthTimeHour', '#ddBirthTimeMinute', '#cbRememberBirthTime'];

    if ((typeof event) != 'undefined') {
        var form = event.target.form;
    } else {
        var form = jQuery('#FormRegister'); // PELO PATTERN EU TENHO ESSA INFORMACAO
    }

    for (var i = 0; i < disable.length; i++) {
        jQuery(disable[i]).attr('disabled', function() {
            return !(jQuery(this).attr('disabled'))
        });
    }

    var noValidate = form.find('#NoValidate_ddBirthTime, [name=NoValidate_ddBirthTime]');

    if (noValidate.length) {
        noValidate.remove();
        jQuery('#ddBirthTime').val(jQuery('#ddBirthTimeHour').val() + jQuery('ddBirthTimeMinute').val());
    } else {
        createHiddenField(form.id, 'NoValidate_ddBirthTime', 1);
        jQuery('#ddBirthTime').val('X');
    }

    var $cbRememberBirthTime = jQuery('#cbRememberBirthTime');

    if ($cbRememberBirthTime.length) {
        if ($cbRememberBirthTime.is(':checked')) {
            jQuery('#ddRememberBirthTimeDays').attr('disabled', true);
            $cbRememberBirthTime.attr('checked', false);
        }
    }
}

function RegisterEmailPop(event) {
    jQuery('#Password_hint, #E-Mail_hint').hide();
    var $field = event.target;
    var value = $field.val();
    if (value.length && confirmedEmail != value) {
        Pop.open(
                'confirmEmail',
                'User/Pop/RegisterEmailConfirm',
                'Email=' + value,
                'default', {'onClose': {'method': RegisterEmailChange, 'args': $field}, 'onComplete': {'method': RegisterEmailConfirm, 'args': value}}
                );
    }
}

function RegisterEmailConfirm(email) {
    Pop.close();
    confirmedEmail = email;
}

function RegisterEmailChange(field) {
    Pop.close();
    jQuery('#E-Mail').val('').focus();
    confirmedEmail = false;
}

function checkFields() {
    var args = checkFields.arguments;
    var form = 'FormRegister';
    for (var i = 0; i < args.length; i++) {
        jQuery(args[i]).attr('checked', function() {
            return !(jQuery(this).attr('checked'));
        });
    }
}


var Register = {
    'enableTrackEvents': false,
    'FormID': 'FormRegister',
    'FormData': '',
    //campos adicionados para as variacoes do cadastro
    'PopFormID': 'PopFormRegister',
    'PopFormSummerTime': 'PopFormRegisterSummerTime',
    'isPopRegister': false,
    'registerFormSubmited': false,
    'pop': function(url,params){
        if( Register.enableTrackEvents == true){
        	fwTrackEventActions('Pop-Cadastro', 'Abrir - Pop de cadastro', 'Abrir - Pop de cadastro');
        }
    	if (typeof(params) == 'undefined') {
    		params = '';
        }
		javascript:Pop.open('deliveryTime','User/Pop/RegisterStep',params+'&ReturnToURL='+url,'default',{'onClose':null});void(0);
		return;
    },
    'goToPopStep': function (step, testABvariation) {
        if (typeof(testABvariation) == 'undefined') {
            testABvariation = '';
        }
        /*verify external campaing*/
        if (typeof(formID) == 'undefined') {
            formID = 'FormRegister';
        }
        if( jQuery(form).find('[name=isPopRegister]').val() == 1 ){
        	Register.isPopRegister = true;
        }else{
        	Register.isPopRegister = false;
        }
        var userData = SendFormDataByAjaxRunMethodSync(formID, 'TemporaryCampaignExternal', 'ctUserVerifyEmailCampaign');
        var objTemporaryCampaing = jQuery.parseJSON( userData );
        if ( objTemporaryCampaing != null ){
        	if ( objTemporaryCampaing.Message == 'renaultduster' ){
        		Pop.open('deliveryTime', 'User/' + 'RegisterLogin', create_request_string('FormRegister'), 'default', {'onClose':null});
                void(0);
                return;
            }
        }
        /*END verify external campaing*/
        if (testABvariation != '') {
            Pop.open('deliveryTime', 'User/' + testABvariation + '/Pop/PopRegisterStep1', create_request_string('FormRegister'), 'default', {'onClose':null});
            void(0);
        } else {
            Pop.open('deliveryTime', 'User/Pop/PopRegisterStep1', create_request_string('FormRegister'), 'default', {'onClose':null});
            void(0);
        }
    },
    'checkSummerTime': function (form) {
        var $form = jQuery(form);

        var data = 'ddCity=' + $form.find('[name=ddCity]').val()
                + '&BirthDate=' + $form.find('[name=ddBirthDate]').val()
                + '&BirthTime=' + $form.find('[name=ddBirthTime]').val();

        var summerTime = SendDataByAjaxRunMethodSync(data, 'Profile', 'CheckSummerTime');
        return parseInt(summerTime);
    },
    'addUser': function (form) {
        if (Register.registerFormSubmited === true) {
            return void(0);
        }
        Register.registerFormSubmited = true;

        if (typeof(form) == 'undefined') {
        	form = 'FormRegister';
        }
        if( jQuery('#'+form).find('[name=isPopRegister]').val() == 1 ) {
        	Register.isPopRegister = true;
        } else {
        	Register.isPopRegister = false;
        }

        var testABvariation = jQuery('#VariationOptmizer').val() || '';
        var dontKnowBirthTime = jQuery('#cbDontKnowBirthTime').is(":checked");
        var hasBirthTime = jQuery('input[name="NoValidate_ddBirthTime"]').val();
        var msgError = '';

        if ( !dontKnowBirthTime && hasBirthTime != 1 ) {
            msgError += TestInputSelect(form, 'ddBirthTimeHour', '- Hora de nascimento.');
            msgError += TestInputSelect(form, 'ddBirthTimeMinute', '- Minuto de nascimento.');
        }

        if (msgError==='') {
            if ( !dontKnowBirthTime && (jQuery('#ddBirthTimeHour').val() != '' && jQuery('#ddBirthTimeMinute').val() != '' ) ) {
                if (Register.checkSummerTime(jQuery('#'+form)) > 0) {
                	 if (testABvariation != '') {
                         Pop.open('deliveryTime', 'User/' + testABvariation + '/Pop/PopRegisterStep2', create_request_string(form), 'default', {'onClose':null});
                         Register.registerFormSubmited = false;
                         return void(0);
                     } else {
                         Pop.open('deliveryTime', 'User/Pop/PopRegisterStep2', create_request_string(form), 'default', {'onClose':null});
                         Register.registerFormSubmited = false;
                         return void(0);
                     }
                }
            }
            Register.saveData(testABvariation,form);
        }else{
            Register.registerFormSubmited = false;
            alert('Por favor preencha corretamente os campos abaixo:\n\n' + msgError);
        }
        return void(0);
    },
    'saveData': function (testABvariation,form) {
        if (typeof(testABvariation) == 'undefined' || testABvariation == '') {
            testABvariation = '';
        }
        SendFormDataByAjaxRunMethod(form, 'User', 'addUser', {'callback': Register.saveDataResultPop, 'extra_data': testABvariation});
    },
    'confirmPop': function () {
    	//pego o valor da variacao no campo oculto do form
    	var testABvariation = jQuery('#VariationOptmizer').val() || '';
    	var form = jQuery('#' + Register.PopFormID);
    	var dontKnowBirthTime = jQuery('#cbDontKnowBirthTime').is(":checked");
    	if (!dontKnowBirthTime) {
    		if (Register.checkSummerTime(form) > 0) {
    			if (testABvariation != '') {
    				SendFormDataByAjaxRunTemplateHistory('User/' + testABvariation + '/Pop/PopRegisterStep2', 'PopFormRegister', function(content) {
    					jQuery('#PopRegister').html(content);
    				});
    			} else {
    				SendFormDataByAjaxRunTemplateHistory('User/Pop/PopRegisterStep2', 'PopFormRegister', function(content) {
    					jQuery('#PopRegister').html(content);
    				});
    			}
    			return void(0);
    		}
    	}
    	Register.saveDataPop(testABvariation);
    	return void(0);
    },
    'saveDataPop': function (testABvariation) {
    	if (typeof(testABvariation) == 'undefined' || testABvariation == '') {
    		testABvariation = '';
    	}
    	SendFormDataByAjaxRunMethod(Register.PopFormID, 'User', 'addUser', {'callback': Register.saveDataResultPop, 'extra_data': testABvariation});
    },
    'saveDatacheckSummerTimePop': function () {
        //pego o valor da variacao no campo oculto do form
        var testABvariation = jQuery('#VariationOptmizer').val();
        if (typeof(testABvariation) == 'undefined') {
            testABvariation = '';
        }
        SendFormDataByAjaxRunMethod(Register.PopFormSummerTime, 'User', 'addUser', {'callback': Register.saveDataResult, 'extra_data': testABvariation});
    },
    'saveDataResult': function (result) {
        result = Boolean(result);
        if (result) {
        	var returnToURl = "/";
    		if( jQuery('#ReturnToURL').val() ){
    			returnToURl = jQuery('#ReturnToURL').val();
    		}
        	if( Register.isPopRegister === true ){
        		document.location.href = returnToURl;
        		return void(0);
        	}else{
        		document.location.href = '/cadastro/obrigado?FeedbackRegister=1&ReturnToURL=' + base64_encode(returnToURl);
        		//document.location.href = returnToURl;
        		return void(0);
        	}
        }
    },
    'saveDataResultPop': function (result, testABvariation) {
        result = Boolean(result);
        if (typeof(testABvariation) == 'undefined' || testABvariation == '') {
            testABvariation = '';
        }
        if (result) {
        	var returnToURl = "/";
    		if( jQuery('#ReturnToURL').val() ){
    			returnToURl = jQuery('#ReturnToURL').val();
    		}
        	if( Register.isPopRegister === true ){
        		document.location.href = returnToURl;
        		return void(0);
        	}else{
        		document.location.href = '/cadastro/obrigado?FeedbackRegister=1&ReturnToURL=' + base64_encode(returnToURl);
        		return void(0);
        	}
        }
    },

    'saveDataResultcheckSummerTimePop': function (result, testABvariation) {
        result = Boolean(result);

        if (typeof(testABvariation) == 'undefined' || testABvariation == '') {
            testABvariation = '';
        }

        if (result) {
            document.location.href = '/cadastro/obrigado?FeedbackRegister=1&ReturnToURL=' + base64_encode(jQuery('#' + Register.FormID).find('[name=ReturnToURL]').val()) + '&variation=' + testABvariation;
            return void(0);
        }
    },

    'ascendant': function() {
        var returnURL = jQuery('#ReturnURL').val();
        mostraLoader();
        SendFormDataByAjaxRunMethod('FormRegisterAscendantLanding', 'User', 'addUser', {'callback': Register.ascendantCallback, 'extra_data': returnURL});
    },

    'ascendantCallback': function(result, returnURL) {
        mostraLoader();
        if (result > 0) {
            document.location.href = '/cadastro/obrigado?FeedbackRegister=1&ReturnToURL=' + base64_encode(returnURL);
        } else {
            alert(result);
        }
    },

    'skyMapEgo': function() {
        mostraLoader();
        SendFormDataByAjaxRunMethod('FormRegisterCampaignMalhacao', 'User', 'addUser', {'callback': Register.skyMapEgoCallback });
    },

    'skyMapEgoCallback': function(result, returnURL) {
        mostraLoader();
        if (result > 0) {
            document.location.href = '/ctl.php?mdl=Horoscopo&cmd=TelaExibeHoroscopo';
        } else {
            alert(result);
        }
    },

	'haircare': function(){
		var returnURL = document.getElementById('ReturnURL').value;
		var result = SendFormDataByAjaxRunMethodSync('FormRegisterHaircare', 'User', 'addUser');
		if(result > 0){
			document.location.href = '/cadastro/obrigado?FeedbackRegister=1&ReturnToURL='+ base64_encode(returnURL);
		}
	},

    'setUserReceiveEmail': function() {
        var returnURL = jQuery('#ReturnToURL').val();

        if (!returnURL) {
            returnURL = jQuery('[name=ReturnToURL]').val();
        }

        var variation = jQuery('#Variation').val();
        var form = 'FormOptinRegisterFeedback';
        var enableCounter = jQuery('#enableCounter').val();
        var data;

        if (enableCounter == '0') {
            //seto o valor de enableCounter para 1 nao contabilizar mais de uma vez o msm checkboxe marcado
            jQuery('#enableCounter').val('1');
            var resultCheckboxNews = valueInputCheck(form, 'cbReceiveNews');
            var resultCheckboxAlerts = valueInputCheck(form, 'cbReceiveAlerts');
            if (variation == 'A') {
                if (resultCheckboxNews) {
                    //seto o contador de click para esse checkbox da versao b
                    data = 'CounterCode=764&setOnlyCounter=1';
                    SendDataByAjaxRunMethod(data, 'Counter', 'setClick');
                }
                if (resultCheckboxAlerts) {
                    //seto o contador de click para esse checkbox da versao b
                    data = 'CounterCode=762&setOnlyCounter=1';
                    SendDataByAjaxRunMethod(data, 'Counter', 'setClick');
                }
            } else if (variation == 'B') {
                if (resultCheckboxNews) {
                    //seto o contador de click para esse checkbox da versao b
                    data = 'CounterCode=768&setOnlyCounter=1';
                    SendDataByAjaxRunMethod(data, 'Counter', 'setClick');
                }
                if (resultCheckboxAlerts) {
                    //seto o contador de click para esse checkbox da versao b
                    data = 'CounterCode=766&setOnlyCounter=1';
                    SendDataByAjaxRunMethod(data, 'Counter', 'setClick');
                }
            } else {
                if (resultCheckboxNews) {
                    //seto o contador de click para esse checkbox da versao b
                    data = 'CounterCode=772&setOnlyCounter=1';
                    SendDataByAjaxRunMethod(data, 'Counter', 'setClick');
                }
                if (resultCheckboxAlerts) {
                    //seto o contador de click para esse checkbox da versao b
                    data = 'CounterCode=770&setOnlyCounter=1';
                    SendDataByAjaxRunMethod(data, 'Counter', 'setClick');
                }
            }
        }

        SendFormDataByAjaxRunMethod('FormOptinRegisterFeedback', 'User', 'setUserReceiveEmail', {'callback': Register.setUserReceiveEmailCallback, 'extra_data': returnURL});
    },
    'setUserReceiveEmailCallback': function(result, returnURL) {

        if (typeof(returnURL) == 'undefined' || returnURL == '') {
            returnURL = '/';
        } else {
        	returnURL = base64_decode(returnURL);
        	var data = 'idUsuario=&url='+returnURL;
        	returnURL = SendDataByAjaxRunMethodSync(data, 'User', 'getUserHashId');
        }

        document.location.href = returnURL;
    }
};

var User = {
    'enableTrackEvents': true,
    'edit': function (userID, returnToUrl, addClassToPop) {
    	if( returnToUrl == '' ||typeof(returnToUrl) == 'undefined' || returnToUrl == null ){
    		returnToUrl = '/seu-perfil/dados';
    	}
    	var addClass = '';
    	if (typeof(addClassToPop) != 'undefined' && addClassToPop != null && typeof(addClassToPop) != 'object' ) {
            addClass = addClassToPop;
        }
        Pop.open(
                'editUser',
                'User/EditUser',
                'UserID=' + userID + '&addClass=' + addClass,
                'default', {'onComplete': {'method': pageRedirect, 'args': returnToUrl}}
                );
    },
    'save': function () {
        SendFormDataByAjaxRunMethod('FormEditUser', 'User', 'updateUserInfoBD', User.saveResult)
    },
    'saveTransitsOptions': function () {
        var valueRadioTransit = valueInputRadio('FormTransitsOptions', 'rbReceiveTransitAlert');
        if (valueRadioTransit !== '') {
            SendFormDataByAjaxRunMethod('FormTransitsOptions', 'User', 'SetUserReceiveEmailData', User.saveResult);
        } else {
            alert('Você precisa escolher uma das opções.');
        }
    },
    'saveResult': function (result) {
        if (result > 0) {
            if (typeof(popCurrent.onCompleteMethod) != 'undefined') {
                popCurrent.complete();
                return;
            }
            popCurrent.close();
        }
    },
    'updateStatusUserPersonare': function(type, userCode, returnToUrl) {
        if (userCode == '' || typeof(userCode) == 'undefined') {
            userCode = '';
        } else {
            userID = base64_decode(userCode);
        }
        if (returnToUrl == '' || typeof(returnToUrl) == 'undefined') {
            returnToUrl = '/';
        }
        if (type != 'BirthTime' && type != '' && typeof(type) != 'undefined') {
            SendDataByAjaxRunTemplate('User/Modules/StatusUserPersonare', '&UserStatusUpdate=' + type, function(content) {
                jQuery('#statusUserPersonare').html(content);
            });
            return;
        }
        if (type == 'BirthTime') {
            if (userID != '' || typeof(userID) != 'undefined') {
                var thisCallback = function() {
                    Pop.close();
                    location.href = returnToUrl;
                };
                Profile.edit(userID, null, {'onComplete': {'method': thisCallback, 'args': null}});
            }
        }
    },

    'closePopStatusUser' : function(returnUrlRefresh) {
        if (typeof(returnUrlRefresh) == 'undefined' || returnUrlRefresh == '') {
            returnUrlRefresh = '/';
        }
        Pop.close();
        document.location.href = returnUrlRefresh;
    },
    'updateEmail' : function(form) {

    	jQuery('#'+form+'_FeedBack').hide("slow");

    	var result = SendFormDataByAjaxRunMethodSync('FormAlertMessageUpdateEmail', 'User', 'updateEmail');

    	if(result){

    		Pop.sucess('EDITAR E-MAIL', "Seu e-mail foi atualizado com sucesso! ;)", {'method': function (e) {
                console.log(e);
            }, 'args': ''}, null);
    		escondeLoader();
            return;

    	}else{

    		jQuery('#'+form+'_FeedBack').attr('class', 'alert');
    		jQuery('#'+form+'_FeedBack').html("Ops! Ocorreu um erro inesperado. Por favor tente novamente atualizar o seu e-mail. Caso não consiga atualizar o seu e-mail entre em contato com o atendimento.");
    		jQuery('#'+form+'_FeedBack').show("slow");
    		escondeLoader();
            return;

    	}

    },
    doFacebookLoginOrSignup: function(returnToURL){
        if( User.enableTrackEvents == true){
            fwTrackEventActions('Facebook', 'Clique - Botao', 'Clique - Botao');
        }
        var data = 'ReturnToURL=' + base64_encode(returnToURL);

        var facebookAuthUrl = SendDataByAjaxRunMethodSync(data, 'User', 'getFacebookAuthLoginUrl');

        pageRedirect(facebookAuthUrl);
        return true;
    },
};

var Cart = {
    /**
     *  As variáveis abaixo implmentam uma lógica no médoto de processamento de pagamento com cartão de crédito
     *    que impede que diversas transações sejam processadas se o cliente clicar várias vezes no botão
     */
    'flagProcessingCreditCard': 0,
    'flagProcessingCreditCardStart':  0,
    'timeWaitSendAgainTransaction': 100,
    'NextStep': 0,
    /**
     * Funcao para testar se o usuario marcou o checkboxe
     * @param testABvariation testABvariation
     * */
    'goToStepConfirm': function (testABvariation) {
        var MsgErr = '';
        if ((testABvariation == '' || typeof(testABvariation) == 'undefined' || testABvariation == 'false')) {
            testABvariation = '';
        }
        var resultCheckbox = jQuery('#cbDataIsOK').val();

        if ((resultCheckbox == '' || typeof(resultCheckbox) == 'undefined' || resultCheckbox == 'false' || resultCheckbox == null)) {
            MsgErr = 'erro';
        }

        if (MsgErr != '') {
            jQuery('#missingSomeData').show();
        } else {
             jQuery('#missingSomeData').hide();
            Cart.goToStep(2, testABvariation);
        }
    },
    'goToStep': function (step, testABvariation) {
        var nextStep = Cart.NextStep;

        if (typeof(testABvariation) == 'undefined') {
            testABvariation = '';
        }

        if (nextStep == 0)
            nextStep = step;

        if (nextStep == 1) {

            if (testABvariation != '') {
                var url = getUrlWithParams('/carrinho/' + testABvariation);

                document.location.href = url;
            } else {
                var url = getUrlWithParams('/carrinho');

                document.location.href = url;
            }

        }
        if (nextStep == 2) {

            if (testABvariation != '') {
                var url = getUrlWithParams('/carrinho/' + testABvariation + '/processando');

                document.location.href = url;
            } else {
                var url = getUrlWithParams('/carrinho/processando');

                document.location.href = url;
            }

        }
        if (nextStep == 3) {

            if (testABvariation != '') {
                var url = getUrlWithParams('/carrinho/' + testABvariation + '/pagamento');

                document.location.href = '/carrinho/' + testABvariation + '/pagamento';
            } else {
                var url = getUrlWithParams('/carrinho/pagamento');

                document.location.href = url;
            }

        }
        if (nextStep == 4) {

            if (testABvariation != '') {
                var url = getUrlWithParams('/carrinho/' + testABvariation + '/confirmacao');

                document.location.href = url;
            } else {
                var url = getUrlWithParams('/carrinho/confirmacao');

                document.location.href = '/carrinho/confirmacao';
            }

        }
    },

    'SetAndChangePaymentOption' : function(option, testABvariation) {

        data = 'Option=' + option;

        if (typeof(testABvariation) == 'undefined' || testABvariation == '') {
            testABvariation = '';
        }

        SendDataByAjaxRunMethod(data, 'Cart', 'SetPaymentOption', {'callback': Cart.ReturnSetPaymentOption, 'extra_data': testABvariation});

    },

    'ReturnSetPaymentOption' : function(code, testABvariation) {
        if (typeof(testABvariation) == 'undefined' || testABvariation == '') {
            testABvariation = '';
        }
        if (code >= 0) {
            // var data = 'PaymentType=' + code;
            if (code == 1) {
                var endUrl = getUrlWithParams('/pagamento/visa');

                if (testABvariation != '') {
                    document.location.href = '/carrinho/' + testABvariation + endUrl;
                } else {
                    document.location.href = '/carrinho' + endUrl;
                }
            }
            else if (code == 2) {
                var endUrl = getUrlWithParams('/pagamento/mastercard');

                if (testABvariation != '') {
                    document.location.href = '/carrinho/' + testABvariation + endUrl;
                } else {
                    document.location.href = '/carrinho' + endUrl;
                }
            }
            else if (code == 3) {
                var endUrl = getUrlWithParams('/pagamento/american-express');

                if (testABvariation != '') {
                    document.location.href = '/carrinho/' + testABvariation + endUrl;
                } else {
                    document.location.href = '/carrinho' + endUrl;
                }
            }
            else if (code == 11) {
                var url = getUrlWithParams('/carrinho/pagamento/maestro');

                document.location.href = url;
            }
            else if (code == 12) {
                var url = getUrlWithParams('/carrinho/pagamento/solo');

                document.location.href = url;
            }
            else if (code == 13) {
                var url = getUrlWithParams('/carrinho/pagamento/discover');

                document.location.href = url;
            }

            else if (code == 5) {
                var endUrl = getUrlWithParams('/pagamento/boleto');

                if (testABvariation != '') {
                    document.location.href = '/carrinho/' + testABvariation + endUrl;
                } else {
                    document.location.href = '/carrinho' + endUrl;
                }
            }
            else if (code == 6) {
                var endUrl = getUrlWithParams('/pagamento/paypal');

                if (testABvariation != '') {
                    document.location.href = '/carrinho/' + testABvariation + endUrl;
                } else {
                    document.location.href = '/carrinho' + endUrl;
                }
            }
            else if (code == 7 || code == 8 || code == 9 || code == 10) {
                var url = getUrlWithParams('/carrinho/confirmacao');

                document.location.href = url;
            }
            else if (code == 0) {
                var endUrl = getUrlWithParams('/pagamento/');

                if (testABvariation != '') {
                    document.location.href = '/carrinho/' + testABvariation + endUrl;
                } else {
                    document.location.href = '/carrinho' + endUrl;
                }
            }

        } else {
            alert('Houve um erro ao selecionar a forma de pagamento, por favor tente novamente. (Erro código: ' + code + ')');
        }
    },
    'SaveConfirmation' : function(arrConfirm) {

        var ItemCartCode = '';

        var sendToEmail = arrConfirm['sendToEmail'];
        var paymentType = arrConfirm['paymentType'];
        var cartCode = arrConfirm['cartCode'];
        var testABvariation = arrConfirm['testABvariation'];
        var resultCheckbox = arrConfirm['cbDataIsOK'];

        var creditCardNumber = arrConfirm['creditCardNumber'];
        var creditCardSecurityCode = arrConfirm['creditCardSecurityCode'];
        var creditCardValidityDate = arrConfirm['creditCardValidityDate'];
        var totalAmount = arrConfirm['totalAmount'];

        if (typeof(paymentType) == 'undefined' || paymentType == '') {
            paymentType = '';
        }
        if (typeof(sendToEmail) == 'undefined' || sendToEmail == '') {
            sendToEmail = '';
        }
        var MsgErr = '';
        if (sendToEmail == '') {
            document.getElementById('save-credit-cart-button').disabled = false;
            jQuery('#missingSendToEmail').show();
        } else {
            jQuery('#missingSendToEmail').hide();
        }
        if (MsgErr != '') {
            document.getElementById('save-credit-cart-button').disabled = false;
            jQuery('#missingSomeData').show();
            return void(0);
        } else {
             jQuery('#missingSomeData').hide();
        }
        var data = '&hdCartCode=' + cartCode + '&txSendToEmail=' + sendToEmail + '&cbDataIsOK=' + resultCheckbox
        + '&creditCardNumber=' + creditCardNumber + '&creditCardSecurityCode=' + creditCardSecurityCode + '&creditCardValidityDate=' + creditCardValidityDate;

        if (paymentType == 1 || paymentType == 2 || paymentType == 3 || paymentType == 4 || paymentType == 11 || paymentType == 12 || paymentType == 13 || paymentType == 14) {

            Cart.flagProcessingCreditCard = Number(new Date()) / 1000;
            if (Cart.flagProcessingCreditCard - Cart.flagProcessingCreditCardStart < Cart.timeWaitSendAgainTransaction) {
                return void(0);
            }
            Cart.flagProcessingCreditCardStart = Cart.flagProcessingCreditCard;
            SendDataByAjaxRunMethod(data, 'Cart', 'SaveConfirmation', {'callback': Cart.ReturnProcessCreditCard});
        } else if (paymentType == 5) {
            SendDataByAjaxRunMethod(data, 'Cart', 'SaveConfirmation', {'callback': Cart.ReturnProcessBill});
        } else if (paymentType == 6) {
            SendDataByAjaxRunMethod(data, 'Cart', 'SaveConfirmation', {'callback': Cart.ReturnProcessPayPal, 'extra_data': testABvariation});
        } else if (paymentType == 7 || paymentType == 8 | paymentType == 9 | paymentType == 10) {
            SendDataByAjaxRunMethod(data, 'Cart', 'SaveConfirmation', {'callback': Cart.ReturnProcessBankAccountDebit});
        }
    },

    'ReturnProcessCreditCard' : function(paymentCode) {
        Cart.flagProcessingCreditCardStart = 0;
        if (paymentCode == -9) {
            Pop.open('cartReturnProcessCreditCard', 'Cart/Answers', '&Answer=32', 'default', {'onClose':null});
            void(0);
        }
        else if (paymentCode == -3) {
            alert('Você não informou o endereço de e-mail para onde será enviada a confirmação de sua compra.');
        }
        else if (paymentCode == -4) {
            alert('O e-mail de confirmação informado parece ser inválido. Verifique se você digitou corretamente.');
        }
        else if (paymentCode < 0) {
            alert('Houve um problema ao alterar o item selecionado. Por favor tente novamente. (Código:' + paymentCode + ")");
        }
        else {
            SetCookie('ItensCartNumber', 0, 0);
            //var urlReturn = '/seu-perfil/seus-servicos/completas?FeedbackPayment=1';
            //urlReturn = base64_encode(urlReturn);
            //document.location.href = '/carrinho/obrigado?returnToUrl=' + urlReturn;
            if (typeof tap === 'function') {
                tap('conversion', paymentCode, totalAmount);
                tap = null;
            }
            var domain = $("#psr-site-full-domain").val();
            if(typeof(domain) == 'undefined'){
                document.location.href = '/seu-perfil/seus-servicos/completas?FeedbackPayment=1';
            }else{
                var productRoute = domain.match(/horoscopo.gshow.globo.com/) ? '/analises' : '/seus-servicos';
                document.location.href = domain + '/seu-perfil' +  productRoute + '/completas?FeedbackPayment=1';
            }
        }

    },

    'ReturnProcessBill' : function (paymentCode) {
        if (paymentCode == -3) {
            alert('Você não informou o endereço de e-mail para onde será enviada a confirmação de sua compra.')
        } else if (paymentCode == -4) {
            alert('O e-mail de confirmação informado parce ser inválido. Verifique se você digitou corretamente.')
        } else if (paymentCode == -5) {
            alert('Olá, gostaríamos que você nos desculpasse, mas nosso sistema de boleto está indisponível no momento. Por favor, escolha outra forma de pagamento ou tente mais tarde.\n\nAgradecemos muito sua compreensão.');
        } else if (paymentCode < 0) {
            alert('Houve um problema ao alterar o item selecionado. Por favor tente novamente. (Código:' + code + ")")
        } else {
            SetCookie('ItensCartNumber', 0, 0)
            urlReturn = '/carrinho/pagamento/boleto/imprimir/' + paymentCode;
            urlReturn = base64_encode(urlReturn);
            document.location.href = '/carrinho/obrigado?returnToUrl=' + urlReturn;
        }
    },

    'ReturnProcessPayPal' : function(paymentCode, testABvariation) {
        if (paymentCode == -3) {
            alert('Você não informou o endereço de e-mail para onde será enviada a confirmação de sua compra.');
        } else if (paymentCode == -4) {
            alert('O e-mail de confirmação informado parce ser inválido. Verifique se você digitou corretamente.');
        } else if (paymentCode < 0) {
            alert('Houve um problema ao alterar o item selecionado. Por favor tente novamente. (Código:' + code + ")");
        } else {
            if (testABvariation == 'a' || testABvariation == 'b' || testABvariation == 'c') {
                document.location.href = '/carrinho/' + testABvariation + '/pagamento/paypal/iniciar/' + paymentCode;
            } else {
                document.location.href = '/carrinho/pagamento/paypal/iniciar/' + paymentCode;
            }
        }
    }
};

function hideActiveX() {
    activeX(false);
}
function showActiveX() {
    activeX(true);
}

function activeX(bool) {
    var status = (bool) ? 'visible' : 'hidden';
    var elements = ['select', 'object', 'embed', 'iframe'];

    var aux;
    for (var i = 0; i < elements.length; i++) {
        aux = document.getElementsByTagName(elements[i]);
        if (aux.length > 0) {
            for (var j = 0; j < aux.length; j++) {

                if (aux[j].id != 'siteLoader') {
                    aux[j].style.visibility = status;
                }

            }
        }
    }
}

function unsubscribleAlertCheck() {
    var data = create_request_string('FormUnsubscribleAlert');
    var result = SendDataByAjaxRunMethodSync(data, 'Validate', 'unsubscribleAlertCheck');

    return result;
}

function redirectToHome(){
    window.location.href = '/';
}

var Alerts = {
    'checkOption': function(e) {

        Feedback.formClear(e.target.form.id);

        var tE = jQuery('#taOtherOption').parent();
        tE.toggle();
    },

    'subscribleAlert': function (type) {
        type = typeof(type) == 'undefined' ? 1 : type;

        if (type == 1) {
            var obj = 'User';
            var method = 'SetUserReceiveEmailData';
            var params = 'cbReceiveAlerts=1';
        } else if (type == 2) {
            var obj = 'User';
            var method = 'SetUserReceivePromotionalEmail';
            var params = 'cbReceiveNews=1';
        }

        //SendDataByAjaxRunMethod('cbReceiveAlerts=1', 'User', 'SetUserReceiveEmailData',
        SendDataByAjaxRunMethod(params, obj, method,
                function (rs) {
                    rs = Boolean(rs);

                    if (rs) {
                        var title = 'RECEBA SEU HORÓSCOPO POR E-MAIL';
                        var message = 'Cadastramento Alerta';

                        if (type == 2) {
                            title = 'RECEBA NOVIDADES E PROMOÇÕES POR E-MAIL';
                            message = 'Cadastramento do e-mail promocional';
                        }

                        //Feedback.pop(utf8_encode('RECEBA SEU HORÓSCOPO POR E-MAIL'), 'Cadastramento Alerta', utf8_encode('Operação realizada com sucesso'), 0, 'javascript:pageRedirect(\'/\')');
                        Feedback.pop(title, message, 'Operação realizada com sucesso', 0, 'javascript:redirectToHome()');
                        return true;
                    }
                }
                );
    },

    'sendUnsubscribleOptions': function (type) {
        SendFormDataByAjaxRunMethod('FormUnsubscribleAlert', 'User', 'SetUnsubscribleAlertOptions',
                function (rs) {
                    rs = Boolean(rs);

                    if (rs) {

                        var title = 'ALERTA';
                        var message = 'Descadastramento alerta';

                        if (type == 2) {
                            title = 'E-MAIL PROMOCIONAL';
                            message = 'Descadastramento e-mail promocional';
                        }else if (type == 3) {
                            title = 'CALENDÁRIO DE CORTE DE CABELO';
                            message = 'Descadastramento e-mail lembrete.';
                        }else if (type == 10) {
	                    	title = 'Tarot e o Amor MINI';
	                    	message = utf8_encode('Obrigado. Sua opinião vai nos ajudar muito.');
	                    }else if (type == 11) {
	                    	title = 'Tarot Semestral MINI';
	                    	message = utf8_encode('Obrigado. Sua opinião vai nos ajudar muito.');
	                    }

                        Feedback.pop(title, message, 'Operação realizada com sucesso.', 0, 'javascript:redirectToHome()');
                        return true;
                    }
                }
                );
    }
};

var jQueryHelper = {
    // Reseta todos os campos de um form
    'formReset' : function(elemento) {
        jQuery(':input', elemento)
                .not(':button, :submit, :reset, :hidden')
                .val('')
                .removeAttr('checked')
                .removeAttr('selected');
    },
    // Reseta todos os campos, inclusive os hidden
    'formResetAll' : function(elemento) {
        jQuery(':input', elemento)
                .not(':button, :submit, :reset')
                .val('')
                .removeAttr('checked')
                .removeAttr('selected');
    }
};

var Helper = {
    'firstChildNode' : function(element) {
        var el;
        if (typeof element == 'String') {
            el = document.getElementById(element).firstChild;
        } else {
            el = element.firstChild;
        }

        while (el && el.nodeType != 1) {
            el = el.nextSibling;
        }

        return el;
    }
};

/**
 * métodos helper herdados do prototype
 */
var Prototype = {

  Version: '1.7',

  Browser: (function(){
    var ua = navigator.userAgent;
    var isOpera = Object.prototype.toString.call(window.opera) == '[object Opera]';
    return {
      IE:             !!window.attachEvent && !isOpera,
      Opera:          isOpera,
      WebKit:         ua.indexOf('AppleWebKit/') > -1,
      Gecko:          ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') === -1,
      MobileSafari:   /Apple.*Mobile/.test(ua)
    }
  })(),

  BrowserFeatures: {
    XPath: !!document.evaluate,

    SelectorsAPI: !!document.querySelector,

    ElementExtensions: (function() {
      var constructor = window.Element || window.HTMLElement;
      return !!(constructor && constructor.prototype);
    })(),
    SpecificElementExtensions: (function() {
      if (typeof window.HTMLDivElement !== 'undefined')
        return true;

      var div = document.createElement('div'),
          form = document.createElement('form'),
          isSupported = false;

      if (div['__proto__'] && (div['__proto__'] !== form['__proto__'])) {
        isSupported = true;
      }

      div = form = null;

      return isSupported;
    })()
  },

  ScriptFragment: '<script[^>]*>([\\S\\s]*?)<\/script>',
  JSONFilter: /^\/\*-secure-([\s\S]*)\*\/\s*$/,

  emptyFunction: function() { },

  K: function(x) { return x }
};
(function() {

  var _toString = Object.prototype.toString,
      NULL_TYPE = 'Null',
      UNDEFINED_TYPE = 'Undefined',
      BOOLEAN_TYPE = 'Boolean',
      NUMBER_TYPE = 'Number',
      STRING_TYPE = 'String',
      OBJECT_TYPE = 'Object',
      FUNCTION_CLASS = '[object Function]',
      BOOLEAN_CLASS = '[object Boolean]',
      NUMBER_CLASS = '[object Number]',
      STRING_CLASS = '[object String]',
      ARRAY_CLASS = '[object Array]',
      DATE_CLASS = '[object Date]',
      NATIVE_JSON_STRINGIFY_SUPPORT = window.JSON &&
        typeof JSON.stringify === 'function' &&
        JSON.stringify(0) === '0' &&
        typeof JSON.stringify(Prototype.K) === 'undefined';

  function Type(o) {
    switch(o) {
      case null: return NULL_TYPE;
      case (void 0): return UNDEFINED_TYPE;
    }
    var type = typeof o;
    switch(type) {
      case 'boolean': return BOOLEAN_TYPE;
      case 'number':  return NUMBER_TYPE;
      case 'string':  return STRING_TYPE;
    }
    return OBJECT_TYPE;
  }

  function extend(destination, source) {
    for (var property in source)
      destination[property] = source[property];
    return destination;
  }

  function inspect(object) {
    try {
      if (isUndefined(object)) return 'undefined';
      if (object === null) return 'null';
      return object.inspect ? object.inspect() : String(object);
    } catch (e) {
      if (e instanceof RangeError) return '...';
      throw e;
    }
  }

  function toJSON(value) {
    return Str('', { '': value }, []);
  }

  function Str(key, holder, stack) {
    var value = holder[key],
        type = typeof value;

    if (Type(value) === OBJECT_TYPE && typeof value.toJSON === 'function') {
      value = value.toJSON(key);
    }

    var _class = _toString.call(value);

    switch (_class) {
      case NUMBER_CLASS:
      case BOOLEAN_CLASS:
      case STRING_CLASS:
        value = value.valueOf();
    }

    switch (value) {
      case null: return 'null';
      case true: return 'true';
      case false: return 'false';
    }

    type = typeof value;
    switch (type) {
      case 'string':
        return value.inspect(true);
      case 'number':
        return isFinite(value) ? String(value) : 'null';
      case 'object':

        for (var i = 0, length = stack.length; i < length; i++) {
          if (stack[i] === value) { throw new TypeError(); }
        }
        stack.push(value);

        var partial = [];
        if (_class === ARRAY_CLASS) {
          for (var i = 0, length = value.length; i < length; i++) {
            var str = Str(i, value, stack);
            partial.push(typeof str === 'undefined' ? 'null' : str);
          }
          partial = '[' + partial.join(',') + ']';
        } else {
          var keys = Object.keys(value);
          for (var i = 0, length = keys.length; i < length; i++) {
            var key = keys[i], str = Str(key, value, stack);
            if (typeof str !== "undefined") {
               partial.push(key.inspect(true)+ ':' + str);
             }
          }
          partial = '{' + partial.join(',') + '}';
        }
        stack.pop();
        return partial;
    }
  }

  function stringify(object) {
    return JSON.stringify(object);
  }

  function toQueryString(object) {
    return $H(object).toQueryString();
  }

  function toHTML(object) {
    return object && object.toHTML ? object.toHTML() : String.interpret(object);
  }

  function keys(object) {
    if (Type(object) !== OBJECT_TYPE) { throw new TypeError(); }
    var results = [];
    for (var property in object) {
      if (object.hasOwnProperty(property)) {
        results.push(property);
      }
    }
    return results;
  }

  function values(object) {
    var results = [];
    for (var property in object)
      results.push(object[property]);
    return results;
  }

  function clone(object) {
    return extend({ }, object);
  }

  function isElement(object) {
    return !!(object && object.nodeType == 1);
  }

  function isArray(object) {
    return _toString.call(object) === ARRAY_CLASS;
  }

  var hasNativeIsArray = (typeof Array.isArray == 'function')
    && Array.isArray([]) && !Array.isArray({});

  if (hasNativeIsArray) {
    isArray = Array.isArray;
  }

  function isHash(object) {
    return object instanceof Hash;
  }

  function isFunction(object) {
    return _toString.call(object) === FUNCTION_CLASS;
  }

  function isString(object) {
    return _toString.call(object) === STRING_CLASS;
  }

  function isNumber(object) {
    return _toString.call(object) === NUMBER_CLASS;
  }

  function isDate(object) {
    return _toString.call(object) === DATE_CLASS;
  }

  function isUndefined(object) {
    return typeof object === "undefined";
  }

  extend(Object, {
    extend:        extend,
    inspect:       inspect,
    toJSON:        NATIVE_JSON_STRINGIFY_SUPPORT ? stringify : toJSON,
    toQueryString: toQueryString,
    toHTML:        toHTML,
    keys:          Object.keys || keys,
    values:        values,
    clone:         clone,
    isElement:     isElement,
    isArray:       isArray,
    isHash:        isHash,
    isFunction:    isFunction,
    isString:      isString,
    isNumber:      isNumber,
    isDate:        isDate,
    isUndefined:   isUndefined
  });
})();
Object.extend(String.prototype, (function() {
  var NATIVE_JSON_PARSE_SUPPORT = window.JSON &&
    typeof JSON.parse === 'function' &&
    JSON.parse('{"test": true}').test;

  function prepareReplacement(replacement) {
    if (Object.isFunction(replacement)) return replacement;
    var template = new Template(replacement);
    return function(match) { return template.evaluate(match) };
  }

  function gsub(pattern, replacement) {
    var result = '', source = this, match;
    replacement = prepareReplacement(replacement);

    if (Object.isString(pattern))
      pattern = RegExp.escape(pattern);

    if (!(pattern.length || pattern.source)) {
      replacement = replacement('');
      return replacement + source.split('').join(replacement) + replacement;
    }

    while (source.length > 0) {
      if (match = source.match(pattern)) {
        result += source.slice(0, match.index);
        result += String.interpret(replacement(match));
        source  = source.slice(match.index + match[0].length);
      } else {
        result += source, source = '';
      }
    }
    return result;
  }

  function sub(pattern, replacement, count) {
    replacement = prepareReplacement(replacement);
    count = Object.isUndefined(count) ? 1 : count;

    return this.gsub(pattern, function(match) {
      if (--count < 0) return match[0];
      return replacement(match);
    });
  }

  function scan(pattern, iterator) {
    this.gsub(pattern, iterator);
    return String(this);
  }

  function truncate(length, truncation) {
    length = length || 30;
    truncation = Object.isUndefined(truncation) ? '...' : truncation;
    return this.length > length ?
      this.slice(0, length - truncation.length) + truncation : String(this);
  }

  function strip() {
    return this.replace(/^\s+/, '').replace(/\s+$/, '');
  }

  function stripTags() {
    return this.replace(/<\w+(\s+("[^"]*"|'[^']*'|[^>])+)?>|<\/\w+>/gi, '');
  }

  function stripScripts() {
    return this.replace(new RegExp(Prototype.ScriptFragment, 'img'), '');
  }

  function extractScripts() {
    var matchAll = new RegExp(Prototype.ScriptFragment, 'img'),
        matchOne = new RegExp(Prototype.ScriptFragment, 'im');
    return (this.match(matchAll) || []).map(function(scriptTag) {
      return (scriptTag.match(matchOne) || ['', ''])[1];
    });
  }

  function evalScripts() {
    return this.extractScripts().map(function(script) { return eval(script) });
  }

  function escapeHTML() {
    return this.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function unescapeHTML() {
    return this.stripTags().replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');
  }


  function toQueryParams(separator) {
    var match = this.strip().match(/([^?#]*)(#.*)?$/);
    if (!match) return { };

    return match[1].split(separator || '&').inject({ }, function(hash, pair) {
      if ((pair = pair.split('='))[0]) {
        var key = decodeURIComponent(pair.shift()),
            value = pair.length > 1 ? pair.join('=') : pair[0];

        if (value != undefined) value = decodeURIComponent(value);

        if (key in hash) {
          if (!Object.isArray(hash[key])) hash[key] = [hash[key]];
          hash[key].push(value);
        }
        else hash[key] = value;
      }
      return hash;
    });
  }

  function toArray() {
    return this.split('');
  }

  function succ() {
    return this.slice(0, this.length - 1) +
      String.fromCharCode(this.charCodeAt(this.length - 1) + 1);
  }

  function times(count) {
    return count < 1 ? '' : new Array(count + 1).join(this);
  }

  function camelize() {
    return this.replace(/-+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
  }

  function capitalize() {
    return this.charAt(0).toUpperCase() + this.substring(1).toLowerCase();
  }

  function underscore() {
    return this.replace(/::/g, '/')
               .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
               .replace(/([a-z\d])([A-Z])/g, '$1_$2')
               .replace(/-/g, '_')
               .toLowerCase();
  }

  function dasherize() {
    return this.replace(/_/g, '-');
  }

  function inspect(useDoubleQuotes) {
    var escapedString = this.replace(/[\x00-\x1f\\]/g, function(character) {
      if (character in String.specialChar) {
        return String.specialChar[character];
      }
      return '\\u00' + character.charCodeAt().toPaddedString(2, 16);
    });
    if (useDoubleQuotes) return '"' + escapedString.replace(/"/g, '\\"') + '"';
    return "'" + escapedString.replace(/'/g, '\\\'') + "'";
  }

  function unfilterJSON(filter) {
    return this.replace(filter || Prototype.JSONFilter, '$1');
  }

  function isJSON() {
    var str = this;
    if (str.blank()) return false;
    str = str.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@');
    str = str.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']');
    str = str.replace(/(?:^|:|,)(?:\s*\[)+/g, '');
    return (/^[\],:{}\s]*$/).test(str);
  }

  function evalJSON(sanitize) {
    var json = this.unfilterJSON(),
        cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    if (cx.test(json)) {
      json = json.replace(cx, function (a) {
        return '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
      });
    }
    try {
      if (!sanitize || json.isJSON()) return eval('(' + json + ')');
    } catch (e) { }
    throw new SyntaxError('Badly formed JSON string: ' + this.inspect());
  }

  function parseJSON() {
    var json = this.unfilterJSON();
    return JSON.parse(json);
  }

  function include(pattern) {
    return this.indexOf(pattern) > -1;
  }

  function startsWith(pattern) {
    return this.lastIndexOf(pattern, 0) === 0;
  }

  function endsWith(pattern) {
    var d = this.length - pattern.length;
    return d >= 0 && this.indexOf(pattern, d) === d;
  }

  function empty() {
    return this == '';
  }

  function blank() {
    return /^\s*$/.test(this);
  }

  function interpolate(object, pattern) {
    return new Template(this, pattern).evaluate(object);
  }

  function removeAccents() {
    var r=this.toLowerCase();
    r = r.replace(new RegExp(/\s/g),"");
    r = r.replace(new RegExp(/[àáâãäå]/g),"a");
    r = r.replace(new RegExp(/æ/g),"ae");
    r = r.replace(new RegExp(/ç/g),"c");
    r = r.replace(new RegExp(/[èéêë]/g),"e");
    r = r.replace(new RegExp(/[ìíîï]/g),"i");
    r = r.replace(new RegExp(/ñ/g),"n");
    r = r.replace(new RegExp(/[òóôõö]/g),"o");
    r = r.replace(new RegExp(/œ/g),"oe");
    r = r.replace(new RegExp(/[ùúûü]/g),"u");
    r = r.replace(new RegExp(/[ýÿ]/g),"y");
    r = r.replace(new RegExp(/\W/g),"");
    return r;
  };

  return {
    gsub:           gsub,
    sub:            sub,
    scan:           scan,
    truncate:       truncate,
    strip:          String.prototype.trim || strip,
    stripTags:      stripTags,
    stripScripts:   stripScripts,
    extractScripts: extractScripts,
    evalScripts:    evalScripts,
    escapeHTML:     escapeHTML,
    unescapeHTML:   unescapeHTML,
    toQueryParams:  toQueryParams,
    parseQuery:     toQueryParams,
    toArray:        toArray,
    succ:           succ,
    times:          times,
    camelize:       camelize,
    capitalize:     capitalize,
    underscore:     underscore,
    dasherize:      dasherize,
    inspect:        inspect,
    unfilterJSON:   unfilterJSON,
    isJSON:         isJSON,
    evalJSON:       NATIVE_JSON_PARSE_SUPPORT ? parseJSON : evalJSON,
    include:        include,
    startsWith:     startsWith,
    endsWith:       endsWith,
    empty:          empty,
    blank:          blank,
    interpolate:    interpolate,
    removeAccents: removeAccents
  };
})());

/*
 * Método responsável para o módulo de busca de cidades no formato autocomplete
 * Tpl
 * /User/CitySearch.tpl
 * */
valor_aux    = '';
CityListCopy   = new Array();
Cities         = new Array();
CityList       = new Array();
var showCities = function(event) {
	var element      = jQuery(event.target);
	var valor        = element.val();
    var elementName  = element.attr('name');
    //variavel local para habilitar os dados de longitude, latitude e GMT para aparecer no label das cidades
    var enablePositionCity = 0;
	if ( element.attr('name') !== 'txPsrOndeNasceu' ) {
		valor_aux =  element.attr('name');
	} else {
		valor_aux =  '';
	}
	var list = jQuery("#Autocomplete_query"+valor_aux);
	//Caso pesquisa com 3 caracteres, realiza pesquisa no banco e retorna novas cidades
	if ( valor.length === 0 ) {
		list.empty();
		list.css('style', 'display:none;');
		list.removeClass().addClass('noerror');
	}
	if ( valor.length === 3 ) {
		var data = elementName + valor;

		//verifico se o parametro para habilitar os dados de longitude, latitude e GMT
		//foi passado
		if( jQuery("#enablePositionCityID").length ){

			//seto para exibir os valores de longitude, latitude e GMT
			enablePositionCity = jQuery("#enablePositionCityID").val();
		}

		var dados = 'enablePositionCity='+enablePositionCity + '&' + elementName + '=' + valor;
		SendDataByAjaxRunMethod(dados, 'City', 'getCityList', {
			'callback' : callbackRefreshCities
		});
	} else {
		if ( valor.length > 3 ) {

			//Realiza pesquisa na lista de cidades preexistente
			var j = 0;
			if (valor_aux == null || valor_aux == undefined ) {
				valor_aux = '';
			}
			if ( valor_aux == '' ) {
				CityList[valor_aux] = CityListCopy[0];//Crio uma cópia da lista
			} else {
				CityList[valor_aux] = CityListCopy[1];//Crio uma cópia da lista
			}
			jQuery('#ddCity' + valor_aux).val(''); //Mata os valores que são validados pelo framework na ediçãao do campo cidade
			jQuery('#ddEstate'+valor_aux).val('');
			jQuery('#ddCountry'+valor_aux).val('');
			//CityList = CityListCopy;//Crio uma cópia da lista
			list.empty();
			var founds = 0;
			try {
			while ( CityList[valor_aux][j].Nome != undefined ) {
				var div = jQuery('<div></div>');// crio a div para cada
				// resultado
				if ( CityList[valor_aux][j].CityName != undefined ) {
					//verificar se dentro da string procurada é igual a sibstring que está no array na posiução e adiciinar ao select
					if ( retira_acentos(valor.toUpperCase()) == retira_acentos(CityList[valor_aux][j].Nome.substr(0,valor.length).toUpperCase()) ) {
						div.addClass('autocompletemover'+valor_aux);
						div.attr('id', CityList[valor_aux][j].CityID); // preencho os atributos
						div.attr('EstateID', CityList[valor_aux][j].EstateID); // preencho os	atributos
						div.attr('CountryID', CityList[valor_aux][j].CountryID); // preencho os atributos
						div.attr('Nome', CityList[valor_aux][j].Nome); // preencho os atributos
						div.attr('CityName', CityList[valor_aux][j].CityName); // preencho os atributos
						div.attr('valor_aux', valor_aux); // preencho os atributos
						div.attr('clicavel', '1'); // preencho os atributos
						div.attr('onclick', 'setCityValue("' + CityList[valor_aux][j].Nome
								+ '","' + CityList[valor_aux][j].CityID + '","' + CityList[valor_aux][j].EstateID
								+ '","' + CityList[valor_aux][j].CountryID + '","'
								+ CityList[valor_aux][j].CityName + '","' + valor_aux + '");'); // envio ao método para liberar a caixa
						div.html(CityList[valor_aux][j].CityName);
						div.appendTo(list);
						founds = founds + 1;
					}
				}
				j = j + 1;
				if ( CityList[valor_aux][j] == undefined) {
					break;
				}
			}
			} catch (err) {
				var error = err;
			}
			if (founds == 0) {
				list.addClass('alert_inline'); // preencho com erro
				var p = jQuery('<p></p>');// crio a div
				p.addClass('nomargin'); // seto classe de erro
				p.text("Cidade não encontrada. Envie um email para atendimento@personare.com.br para que possamos incluí-la.");
				p.appendTo(list);
			}  else {
				try {

					list.children('p').remove(); // variavel p não esta definido!
				}catch(err){}

                list.removeClass();

                var classNameIE = (document.all ? 'autocomplete_ie' : 'autocomplete');

				list.addClass(classNameIE);
				list.attr('style', 'display:block;');
			}
		} else if ( valor.length == 2 || valor.length == 1  ) {
			list.empty();
			list.attr('style', 'display:none');
			list.removeClass().addClass('noerror');
		}

	}
};

function sleep(milliseconds) {
	  var start = new Date().getTime();
	  for (var i = 0; i < 1e7; i++) {
	    if ((new Date().getTime() - start) > milliseconds){
	      break;
    }
  }
}

function AddUserHairCare (){
	var objType = valueInputRadio('FormHaircare','rdTipo');//pego o objetivo selecionado
	profileID = jQuery('#ddProfile').val();
	if (profileID == 'AddProfile'){
		var callback = function (){
		  mostraLoader();
		  SetCookie('OBJTYPE',objType,0);
	      FriendsList.linkTo('/astrologia/calendario-corte-de-cabelo', 'LNK');
	    };
		FriendsList.addFriend(false,callback);
		return void(0);
	}
}

function RefreshEditProfileForm () {
	SendFormDataByAjaxRunTemplate('Profile/EditProfile','FormEditProfile', {'callback': SetDivContent, 'extra_data': 'tmpContent'});
}

function autoCompleteTwoCharacterMinLength( element ){
	return !( element.length <= 2 );
}


//Inicio -- SystemLog
	var systemLogOptions = {
		id : null,
		title : '',
		action : '',
		user : '',
		date : '',
		olddata : '',
		newdata : '',
		typelogid : 0,
		identificationCode : ''
	}, systemLogTarget = {};

	var SystemLog = function(options){

		systemLogTarget = jQuery.extend( systemLogOptions, options );

		this.id = systemLogTarget.id;
		this.title = systemLogTarget.title;
		this.action = systemLogTarget.action;
		this.user = systemLogTarget.user;
		this.date = systemLogTarget.date;
		this.olddata = systemLogTarget.olddata;
		this.newdata = systemLogTarget.newdata;
		this.typelogid = systemLogTarget.typelogid;
		this.identificationCode = systemLogTarget.identificationCode;

		this.setLog = function(){
			var dados = 'id='+ this.id +
			'&title=' + this.title +
			'&action=' + this.action +
			'&user=' + this.user +
			'&olddata=' + this.olddata +
			'&newdata=' + this.newdata +
			'&typelogid=' + this.typelogid +
			'&identificationCode=' + this.identificationCode;
			SendDataByAjaxRunMethod(dados, 'SystemLog', 'ctajaxInserts');
		};
		this.processUC = function(){
			if( (typeof(GetCookie('UC')) == 'string') && (GetCookie('UC') != "0") ){
				return SendDataByAjaxRunMethodSync('', 'User', 'ctGetUserID');
	    	}else{
	    		return 0;
	    	}
		};
		this.getToday = function(){
			var date = new Date();
			var d = date.getDate();
		    var m = date.getMonth()+1;
		    var y = date.getFullYear();
		    return '' + y +''+ (m<=9?'0'+m:m) +''+ (d<=9?'0'+d:d);
		};
		this.parseQueryString = function(queryString){
			var arr = queryString.split('&');
			var ret = {};
			for (var i=0;i<arr.length;i++) {
			    var pair = arr[i].split("=");
			    ret[pair[0]] = pair[1];
			}
			return ret;
		};
	};
//Fim -- SystemLog

//Widget para exibir artigos de parceiros

var psrWidgetArticles = {
    stringTop : '<div class="psr-artigos-grupo" id="psr-artigos-grupo-container">\
    <div class="bl-parceiros-fourcol">\
    <h4 class="no-bold">N&Oacute;S INDICAMOS</h4>\
    <div class="shadow"></div>\
    <ul id="psr-artigos-grupo-lista">',
    stringBottom : '</ul>\
    </div>\
    </div>',
    PSRFooterStringTop : '<div class="container-footer">\
    <h5>N&Oacute;S INDICAMOS</h5>\
    <ul>',
    PSRFooterStringBottom : '</ul>\
    </div>',
    setContent: function(content, element)
    {
        if(content != ''){
            if(element=='partner-articles-list-psrfooter'){
                content = psrWidgetArticles.PSRFooterStringTop + content + psrWidgetArticles.PSRFooterStringBottom;
            }else{
                content = psrWidgetArticles.stringTop + content + psrWidgetArticles.stringBottom;
            }
        }
        document.getElementById(element).innerHTML=content;
    },
    loadFile: function(url)
    {
        var js = document.createElement("script");
        js.type = "text/javascript";
        js.src = url;
        document.body.appendChild(js);
    },
    processList : function(value, element){
        var content = '';
        for (var i=0; i < 4; i++) {
            if( ( typeof(value.PartnerArticlesListImg[i]) == 'string' ) && ( typeof(value.PartnerArticlesListUrl[i]) == 'string' ) && ( typeof(value.PartnerArticlesListText[i]) == 'string' ) && ( typeof(value.PartnerArticlesListSite[i]) == 'string' ) ){
                content+='<li><a target="_blank" href="'+value.PartnerArticlesListUrl[i]+'">';
                content+='<img border="0" title="'+value.PartnerArticlesListText[i]+'" alt="" src="'+value.PartnerArticlesListImg[i]+'" />';
                content+='<div><span>'+value.PartnerArticlesListSite[i]+'</span><p>'+value.PartnerArticlesListText[i]+'</p></div>';
                content+='</a></li>';
            }else{
                content = '';
                break;
            }
        }
        psrWidgetArticles.setContent(content, element);
    },
    processListPages : function(value, element){
        var  obj = this;
        switch( value.length ){
            case 6:
                obj.makeHighlight( value, element );
                break;
            case 14:
                obj.makeHighlightFull( value, element );
                break;
            default:
                obj.makeHighlight( value, element );
                break;
        }
    },
    makeHighlight : function(value, element){
        var content = '';
        this.stringTop = "";
        this.stringBottom = "";
        content += '<div id="magazine_modules_highlightlist">';
            content += '<h5 class="subtitle bold nomargin">REVISTA PERSONARE</h5>';
            content += '<div class="hairline clearfix floats">';
                content += '<div class="fL">';
                    content = this.listMakeLargeTemplate(value.slice(0,1),content);
                content+= '</div>';
                content+= '<div class="fR">';
                    content = this.listMakeLargeTemplate(value.slice(1,2),content);
                content+= '</div><br/>';
                content += '<div class="fL">';
                    content = this.listMakeLargeTemplate(value.slice(2,3),content);
                content+= '</div>';
                content+= '<div class="fR">';
                    content = this.listMakeLargeTemplate(value.slice(3,4),content);
                content+= '</div>';
            content+= '</div>';
            content = this.listMakeSmallTemplate(value.slice(4),content);
        content+= '</div>';
        psrWidgetArticles.setContent(content, element);
    },
    makeHighlightFull : function(value, element){
        var content = '';
        this.stringTop = "";
        this.stringBottom = "";
        content += '<div class="row">';
            content += '<div class="col-md-6 col-sm-6">';
                content = this.listMakeLargeTemplate(value.slice(0,1),content);
            content+= '</div>';
            content+= '<div class="col-md-6 col-sm-6">';
                content = this.listMakeLargeTemplate(value.slice(1,2),content);
            content+= '</div>';
        content+= '</div>';
        content += '<div class="row">';
            content += '<div class="col-md-6 col-sm-6">';
                content = this.listMakeLargeTemplate(value.slice(2,3),content);
            content+= '</div>';
            content+= '<div class="col-md-6 col-sm-6">';
                content = this.listMakeLargeTemplate(value.slice(3,4),content);
            content+= '</div>';
        content+= '</div>';
        content += '<div class="row">';
            content += '<div class="col-md-6 hidden-xs">';
                content = this.listMakeSmallTemplate(value.slice(4,8),content);
            content+= '</div>';
            content+= '<div class="col-md-6 hidden-xs">';
                content = this.listMakeSmallTemplate(value.slice(8),content);
            content+= '</div>';
        content+= '</div>';
        psrWidgetArticles.setContent(content, element);
    },
    listMakeLargeTemplate : function(list,content){
        for (var i=0; i < list.length; i++) {
            content += this.templateItemLargeHightlight(list[i]);
        }
        return content;
    },
    listMakeSmallTemplate : function(list,content){
        for (var i=0; i < list.length; i++) {
            content += this.templateItemSmallHightlight(list[i]);
        }
        return content;
    },
    templateItemLargeHightlight : function(value){
      return '<div class="magazine_highlight is-'+ value.areaLifeColor + ' ' + value.areaLifeColor+'-ch">\
                <div class="medium">\
                  <small class="t-cat-art">\
                      <a href="'+value.categoryRedirectUrl+'">'+value.category+'</a>\
                  </small>\
                  <a href="'+value.redirectUrl+'">\
                    <div style="background: url('+value.image+') no-repeat center;" class="image principal"></div>\
                    <h2>'+value.title+'</h2>\
                    <p rel="description" class="nomargin description">'+value.description+'</p>\
                  </a>\
                </div>\
              </div>';
    },
    templateItemSmallHightlight : function(value){
        return '<div class="hairline is-'+ value.areaLifeColor + ' ' + value.areaLifeColor+'-ch">\
                  <div class="magazine_highlight">\
                    <div class="small clearfix">\
                      <a href="'+value.redirectUrl+'">\
                        <div class="image principal">\
                          <img alt="'+value.title+'" src="'+value.image+'" />\
                        </div>\
                      </a>\
                      <a href="'+value.categoryRedirectUrl+'">\
                        <small>'+value.category+'</small>\
                      </a>\
                      <a href="'+value.redirectUrl+'">\
                        <h2 class="bold">'+value.title+'</h2>\
                        <p rel="description" class="nomargin description">'+value.description+'</p>\
                      </a>\
                    </div>\
                  </div>\
                </div>';
    },
    init: function(url){
        psrWidgetArticles.loadFile(url);
    }
};

// Carrega SWFs de publicidade (parametros: local aonde o swf sera carregado (nome da id ou classe), nome da peca (ex: super, super_expand, sky_left, etc), largura, altura, caminho do SWF, cor de fundo, parametro scale no flash - opcional)
// Obs: Metodo especifico dos banners externos, para que ele nao crie divs especiais na ausencia do plugin Flash. Para outros SWFs, utilizar o SWFObject (carregado do Personare.framework.js, documentacao na internet)
function loadSWF(location, name, width, height, path, bgColor, scale) {
	if (scale === undefined) {
		scale = 'noborder';
	}
	jQuery(location).append('<div id="' + name + '"><object id="' + name + '_swf" classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" width="' + width + '" height="' + height + '" align="middle"><param name="movie" value="' + path + '" /><param name="quality" value="high" /><param name="bgcolor" value="' + bgColor + '" /><param name="play" value="true" /><param name="loop" value="true" /><param name="wmode" value="transparent" /><param name="scale" value="' + scale + '" /><param name="menu" value="false" /><param name="devicefont" value="false" /><param name="salign" value="t" /><param name="allowScriptAccess" value="sameDomain" /><!--[if !IE]>--><object type="application/x-shockwave-flash" data="' + path + '" width="' + width + '" height="' + height + '"><param name="movie" value="' + path + '" /><param name="quality" value="high" /><param name="bgcolor" value="' + bgColor + '" /><param name="play" value="true" /><param name="loop" value="true" /><param name="wmode" value="transparent" /><param name="scale" value="' + scale + '" /><param name="menu" value="false" /><param name="devicefont" value="false" /><param name="salign" value="t" /><param name="allowScriptAccess" value="sameDomain" /><!--<![endif]--><a href="http://www.adobe.com/go/getflash"><img src="http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif" alt="Get Adobe Flash player" /></a><!--[if !IE]>--></object><!--<![endif]--></object></div>');
}

jQuery(document).ready(function() {
    /**
     * Se o usuario se logou atraves da pop de selecao de perfil abro a pop para ele escolher um perfil
     * */
	if( Profile.checkCurrentPageAllowedToSelectProfileProduct()
        && Profile.checkSelectProfileProductIDBeforeLogin() === true ){
			Profile.select(Profile.getLastSelectProfileProductID());
			SetCookie('isSelectProfileProductIDBeforeLogin', 0);
	}
});

function fwReplaceAll(find, replace, str) {
  return str.replace(new RegExp(find, 'g'), replace);
}

var Base64 = {


	    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",


	    encode: function(input) {
	        var output = "";
	        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	        var i = 0;

	        input = Base64._utf8_encode(input);

	        while (i < input.length) {

	            chr1 = input.charCodeAt(i++);
	            chr2 = input.charCodeAt(i++);
	            chr3 = input.charCodeAt(i++);

	            enc1 = chr1 >> 2;
	            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	            enc4 = chr3 & 63;

	            if (isNaN(chr2)) {
	                enc3 = enc4 = 64;
	            } else if (isNaN(chr3)) {
	                enc4 = 64;
	            }

	            output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

	        }

	        return output;
	    },


	    decode: function(input) {
	        var output = "";
	        var chr1, chr2, chr3;
	        var enc1, enc2, enc3, enc4;
	        var i = 0;

	        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

	        while (i < input.length) {

	            enc1 = this._keyStr.indexOf(input.charAt(i++));
	            enc2 = this._keyStr.indexOf(input.charAt(i++));
	            enc3 = this._keyStr.indexOf(input.charAt(i++));
	            enc4 = this._keyStr.indexOf(input.charAt(i++));

	            chr1 = (enc1 << 2) | (enc2 >> 4);
	            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	            chr3 = ((enc3 & 3) << 6) | enc4;

	            output = output + String.fromCharCode(chr1);

	            if (enc3 != 64) {
	                output = output + String.fromCharCode(chr2);
	            }
	            if (enc4 != 64) {
	                output = output + String.fromCharCode(chr3);
	            }

	        }

	        output = Base64._utf8_decode(output);

	        return output;

	    },

	    _utf8_encode: function(string) {
	        string = string.replace(/\r\n/g, "\n");
	        var utftext = "";

	        for (var n = 0; n < string.length; n++) {

	            var c = string.charCodeAt(n);

	            if (c < 128) {
	                utftext += String.fromCharCode(c);
	            }
	            else if ((c > 127) && (c < 2048)) {
	                utftext += String.fromCharCode((c >> 6) | 192);
	                utftext += String.fromCharCode((c & 63) | 128);
	            }
	            else {
	                utftext += String.fromCharCode((c >> 12) | 224);
	                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
	                utftext += String.fromCharCode((c & 63) | 128);
	            }

	        }

	        return utftext;
	    },

	    _utf8_decode: function(utftext) {
	        var string = "";
	        var i = 0;
	        var c = c1 = c2 = 0;

	        while (i < utftext.length) {

	            c = utftext.charCodeAt(i);

	            if (c < 128) {
	                string += String.fromCharCode(c);
	                i++;
	            }
	            else if ((c > 191) && (c < 224)) {
	                c2 = utftext.charCodeAt(i + 1);
	                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
	                i += 2;
	            }
	            else {
	                c2 = utftext.charCodeAt(i + 1);
	                c3 = utftext.charCodeAt(i + 2);
	                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
	                i += 3;
	            }

	        }

	        return string;
	    }

	};

var fwBrowser = {
    browserName : '',
    version : '',
    matchMedia: '',
    isMobile: function()
    {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
            return true;
        }else{
            return false;
        }
    },
    checkBrowser: function()
    {
        if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
            this.browserName = 'ie';
            this.version = new Number(RegExp.$1);
        }else if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            this.browserName = 'firefox';
            this.version = new Number(RegExp.$1);
        }else if (/Chrome[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            this.browserName = 'chrome';
            this.version = new Number(RegExp.$1);
        }else if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            this.browserName = 'opera';
            this.version = new Number(RegExp.$1);
        }else if (/Safari[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
            this.browserName = 'safari';
            this.version = new Number(RegExp.$1);
        }
        if(this.browserName != '' && this.version != ''){
            $('body').addClass(this.browserName)
            .addClass(this.browserName+this.version);
        }
    },
    checkMediaQuery: function(rule)
    {
        if( this.browserName == 'ie' && this.version <= 9 ){
            return false;
        }else{
            this.matchMedia = window.matchMedia( rule );
            if ( this.matchMedia.matches ) {
                return true;
            } else {
                return false;
            }
        }
    }
};

var FacebookAds = function () {
    function _trackProduct(productId, type) {
        if (typeof fbq !== 'undefined') {
            fbq('track', "ViewContent", {
                    'content_ids': [productId],
                    'content_type': type
                }
            );
        }
    }

    return {
        trackProduct: function (productId) {
            _trackProduct(productId, 'product');
        },
        trackProductMini: function (productId) {
            _trackProduct(productId, 'product-mini');
        }
    }
}();

$(document).ready(function(){
    fwBrowser.checkBrowser();
});


var mandala = function() {
    this.get = function( queryString,type, urlSwf, id, cdnUrl,height, width ){
        this.queryString = queryString;
        this.urlSwf = urlSwf;
        this.id = id;
        this.type = type;
        this.cdnUrl = cdnUrl;
        this.height = height;
        this.width = width;
        this.render();
    };
    this.render = function(){
        if(fwBrowser.browserName == 'ie' && fwBrowser.version == '8')
            this.flash();
        else
            this.canvas();
    };

    this.canvas = function(){
        var element = document.createElement("iframe");
        element.src = this.cdnUrl + "/site/mandala/" + this.type + "?" + this.queryString
        element.className = "psr-mandala";
        element.scrolling = "no";
        var mandalaDiv = document.getElementById(this.id);
        mandalaDiv.appendChild(element);
    };

    this.flash = function(){
        var swf = this.urlSwf;
        var params = {
            scale: "Scale",
            salign: "T",
            wmode: "transparent",
            flashvars: this.queryString
        };
        var attributes = {};

        swfobject.embedSWF(
            swf,
            this.id,
            this.width,
            this.height,
            "9.0.0",
            swf,
            this.queryString,
            params,
            attributes
        );
    };

};

$(document).ready(function(){
    var body = document.body || document.getElementsByTagName('body')[0];
    var iterator = 0,
        max = 20;
    var checkingTheBodySize = setInterval(function(){
        if (iterator === max) {
            window.clearInterval(checkingTheBodySize);
        } else {
            if (body.clientWidth <= 1010) {
                body.className += ' bodycombg';
                window.clearInterval(checkingTheBodySize);
            }
        }
        iterator++;
    }, 1000);
});
